export default {
  general: {
    activate: 'Activate',
    add: 'Add',
    any: 'Any',
    avatar: 'Avatar',
    apply: 'Apply',
    access_level: 'Access level',
    app_user_settings: 'App & User settings',
    amount: 'Amount',
    all: 'All',
    all_tags: 'All tags',
    assignees: 'Assignees',
    add_favorite: 'Add favorite',
    add_user: 'Add user | Add users',
    add_tag: 'Add tag | Add tags',
    add_task: 'Add task | Add tasks',
    add_group: 'Add group | Add groups',
    add_phase: 'Add phase | Add phases',
    add_account: 'Add account | Add accounts',
    add_to_group: 'Add to group',
    add_to_projects: 'Add to projects',
    add_projects_to_users: 'Add all selected users to projects',
    add_users_to_group: 'Add all selected users to a group',
    add_new: 'Add new',
    add_time: 'Add time',
    archived: 'Archived | Archived',
    active: 'Active',
    archive: 'Archive',
    archive_clients: 'Archive clients',
    assigned_to: 'Assigned to',
    additional_info: 'Additional info',
    an_unexpected_error_occurred: 'An unexpected error occurred.',
    billed: 'Billed',
    billable: 'Billable',
    billing_status: 'Billing status',
    budget_amount: 'Budget amount',
    bill_by_hour: 'Bill by the hour, with billable rates',
    bill_a_set_price: 'Bill a set price, regardless of time tracked',
    billing: 'Billing',
    bulk_edit: 'Bulk edit {number} {el}',
    budget: 'Budget | Budget',
    billed_expenses: 'Billed expenses',
    billed_time: 'Billed time',
    close: 'Close',
    board: 'Board',
    clear_filters: 'Clear Filters',
    change_account: 'Change account',
    change: 'Change',
    configuration: 'Configuration',
    category: 'Category | Categories',
    client: 'Client | Clients',
    click_to_add: 'Click here to add a new one.',
    cost: 'Cost | Costs',
    confirm: 'Confirm',
    calendar: 'Calendar',
    creation_date: 'Creation date',
    cancel: 'Cancel',
    color: 'Color',
    client_id: 'Client ID',
    common: 'Common',
    changes_need_saved: 'Changes need saving',
    create: 'Create',
    create_new_expense_category: 'Create new expense category',
    create_new_project: 'Create new project',
    copy: 'Copy',
    country: 'Country | Countries',
    current_value_out_of_total_value: '{current_value} out of {total_value}',
    currency_per_hour: '{currency} / hour',
    custom: 'Custom',
    copy_phase_from: 'Copy phases from...',
    change_calendar: 'Change calendar',
    choose_calendar: 'Choose calendar where you want to import your events from',
    deactivate: 'Deactivate',
    deactivated: 'Deactivated',
    deactivated_element: 'Deactivated element',
    date: 'Date',
    day: 'Day | 1 day | {number} days',
    deleted: 'Deleted | Deleted',
    deleted_entry: 'Entry deleted',
    deleted_timer: 'Timer deleted',
    deleted_suggestion: 'Suggestion deleted',
    delete: 'Delete',
    delete_confirmation_report: 'Do you want to delete this report?',
    dismiss: 'Dismiss',
    done: 'Done',
    dpa: 'DPA',
    drop_image_here: 'Drop your image here',
    drop_your_image: 'Drop your image anywhere or click here to select from your device',
    delete_element_alert: ' | You\'re about to delete {name} | You\'re about to delete {number} {element}',
    description: 'Description',
    due_date: 'Due date',
    e_mail: 'E-mail | E-mails',
    entries_log: 'Entries log',
    expense: 'Expense | Expenses',
    expense_category: 'Expense category | Expense categories',
    expense_deletion: 'Expense deletion',
    edit: 'Edit',
    export: 'Export',
    edit_tag_list: 'Edit tag list',
    entry: 'Entry | Entries',
    estimate: 'Estimate',
    field_required: 'This field is required',
    filters: 'Filters',
    fixed_fee: 'Fixed fee',
    from: 'From',
    get_started: 'Get started',
    group: 'Group | Groups',
    has_been_archived: 'The linked phase/project has been archived, or you may have been removed from the project.',
    has_been_updated: '{el} has been updated',
    help_desk: 'Help Desk',
    hourly: 'Hourly',
    hourly_rate: 'Hourly Rate',
    hourly_cost: 'Hourly cost',
    job_title: 'Job title',
    keyboard_shortcuts: 'Keyboard shortcuts',
    import_from_ms: 'Import from MS To Do',
    integration: 'Integration | Integrations',
    learn_more: 'Learn more',
    login: 'Log in',
    light: 'Light',
    leave_unchanged: 'Leave unchanged',
    locked_entry: 'Locked entry.',
    lock: 'Lock',
    list: 'List',
    legacy: 'Legacy',
    labour_costs: 'Labour costs',
    last_sync: 'Last sync {el}',
    load_more: 'Load more',
    loading_integration: 'Loading integration...',
    linked_project_api_only: {
      body: 'The linked project is {0} and the entry can be edited only via APIs.',
      api_only: 'API only'
    },
    manager: 'Manager | Managers',
    member: 'Member | Members',
    manage: 'Manage',
    me: 'Me',
    menu: 'Menu',
    manage_integration: 'Manage integration | Manage integrations',
    my_tasks: 'My Tasks',
    monetary_budget: 'Monetary budget',
    multiple_new_projects: 'Multiple new projects by template',
    new_project: 'New project',
    new_team_members: 'New team members',
    no_data: 'No data',
    no_budget: 'No budget',
    no_data_for: 'No data for current period',
    none: 'None',
    note: 'Note | Notes',
    name: 'Name | Names',
    notifications: 'Notifications',
    notes_and_integration_info: 'Notes and integration info',
    no_tags: 'No tags',
    not_assigned: 'Not assigned',
    no_data_available: 'No data available',
    not_billable: 'Not billable',
    non_billable: 'Non-billable',
    not_billable_to_client: 'Not billed to a client',
    no_data_found: 'No data found',
    n_a: 'N/A',
    number_member_selected: '{number} members selected | One member selected | {number} members selected',
    number_category_selected: '{number} category selected | One category selected | {number} category selected',
    number_expense_category_selected: '{number} expense category selected | One expense category selected | {number} expense category selected',
    number_tag_selected: '{number} tag selected | One tag selected | {number} tag selected',
    number_tag_list_selected: '{number} tag list selected | One tag list selected | {number} tag list selected',
    number_todo_selected: '{number} task selected | One task selected | {number} task selected',
    number_todo_list_selected: '{number} task list selected | One task list selected | {number} task list selected',
    number_country_selected: '{number} country selected | One country selected | {number} country selected',
    number_external_selected: '{number} external selected | One external selected | {number} external selected',
    number_user_selected: '{number} users selected | One user selected | {number} users selected',
    number_group_selected: '{number} group selected | One group selected | {number} group selected',
    number_user_updated: '{number} users updated | One user updated | {number} users updated',
    number_client_selected: '{number} clients selected | One client selected | {number} clients selected',
    number_client_unarchived: '{number} clients unarchived | One client unarchived | {number} clients unarchived',
    number_expense_selected: '{number} expenses selected | One expense selected | {number} expenses selected',
    number_project_selected: '{number} projects selected | One project selected | {number} projects selected',
    number_project_updated: '{number} projects updated | One project updated | {number} projects updated',
    number_project_deleted: '{number} projects deleted | One project deleted | {number} projects deleted',
    import_data: 'Import data',
    import_from: 'Import from',
    insert_password: 'Insert password',
    integration_info: 'Integration info',
    info: 'Info',
    in_progress: 'In progress',
    or: 'or',
    please_check_filters: 'Please check filters and try again',
    public: 'Public',
    password: 'Password',
    phone_number: 'Phone number',
    this_should_be_phone_number: 'This should be a phone number',
    priority: 'Priority',
    project: 'Project | Projects',
    project_hourly_rate: 'Project hourly rate',
    project_hourly_rate_required_for: 'The project hourly rate is required to calculate the monetary value of your time and keep the project budget updated',
    phase: 'Phase | Phases',
    phase_category: 'Phase category | Phase categories',
    product: 'Product',
    pre_select_projects: 'Pre-select projects for imported events',
    passwords_do_not_match: 'Passwords do not match',
    personal_access_tokens: 'Personal access tokens',
    project_with_no_tags: 'This project has no tags.',
    progress: 'Progress',
    project_budget: 'Project budget',
    project_fee: 'Project fee',
    report: 'Report | Reports',
    required: 'Required',
    read_article: 'Read the article',
    required_at_least_one_tag: 'Require at least one tag for each time entry',
    reload: 'Reload',
    repeat_password: 'Repeat password',
    remove: 'Remove',
    remove_favorite: 'Remove favorite',
    register_time: 'Register time',
    report_delete_advertisment: 'After confirmation every automation associated to this report will be deleted',
    report_delete_error: 'There was a problem during the deletion of this report.',
    required_field: 'Required field',
    revenue: 'Revenue',
    timesheet: 'Timesheet | Timesheets',
    time_spent: 'Time spent',
    update_password: 'Update password',
    updating_your_password: 'Updating your password...',
    un_archive: 'Un-archive',
    unit_price: 'Unit price',
    update: 'Update',
    updated: 'Updated | Updated',
    updated_last_project: 'Project updated',
    user: 'User | Users',
    user_deactivated: 'User deactivated.',
    undo_deletion: 'Undo deletion',
    unknown_phase: 'Unknown phase',
    users_will_not_be_able_track_time: 'Users will not be able to tag their time entries',
    users_will_be_able_to_tag_any_tag: 'Users will be able to tag their time entries with any workspace tag',
    users_will_be_able_to_tag_selected_tag_list: 'Users will be able to tag their time entries only with selected tag lists',
    unarchived: 'Unarchived',
    unbilled_expenses: 'Unbilled expenses',
    unbilled: 'Unbilled',
    unbilled_time: 'Unbilled time',
    unbilled_money: 'Unbilled money',
    unbilled_explain: 'Unbilled money = unbilled labor + unbilled expenses + unbilled fixed fee',
    updated_data: 'Some data has changed from last page load',
    start_timer: 'Start Timer',
    save_entry: 'Save Entry',
    sync_private_appointments: 'Sync private appointments',
    set_hourly_rate: 'Set hourly rate',
    set_hourly_cost: 'Set hourly cost',
    set_expense_lock: 'Set expense lock',
    set_billing_status: 'Set billing status',
    select_tags: 'Select tag | Select tags',
    select_assignees: 'Select assignees',
    select_status: 'Select status',
    select_priority: 'Select priority',
    start_date: 'Start date',
    sla: 'SLA',
    save: 'Save',
    show: 'Show',
    sort_by: 'Sort by',
    full_name: 'Full Name',
    search_within_expense_categories: 'Search within expense categories',
    start_tracking_time: 'Start tracking time',
    select_all: 'Select All',
    select_calendar: 'Select a calendar',
    set_access_level: 'Set access level',
    set_access_level_user: 'Set access level to all selected users',
    seconds: 'Seconds',
    team: 'Team | Teams',
    tag: 'Tag | Tags',
    to: 'To',
    total: 'Total | Totals',
    time: 'Time',
    timer: 'Timer | Timers',
    tag_list: 'Tag list | Tag lists',
    tag_lists: 'Tag lists',
    todo_list: 'Task List',
    task: 'Task | Tasks',
    task_list: 'Task list',
    time_worked: 'Time worked',
    total_time: 'Total time',
    total_cost: 'Total cost',
    total_revenues: 'Total revenue',
    total_billed: 'Total billed',
    terms_conditions: 'Terms & conditions',
    team_member: 'Team member | Team members',
    timer_started: 'Timer started.',
    timer_saved: 'Timer saved.',
    timer_paused: 'Timer paused',
    time_budget: 'Time budget',
    time_tracked: 'Time tracked',
    timezone: 'Timezone',
    timeframe: 'Timeframe',
    table_configuration: 'Table Configuration',
    tag_lists_and_tags: 'Tag lists & tags',
    time_and_material: 'Time & Material',
    url: 'URL',
    optional: 'optional',
    optional_notes: 'Optional notes for reference',
    overview: 'Overview',
    other: 'Other | Others',
    you_are_about_to_add_element: 'You are about to add <b>{number} {first_el} to {article} {second_el}</b>.<br/> This action requires confirmation',
    working_time: 'Working time',
    without_element: 'Without {el}',
    watch_the_video: 'Watch the video',
    workspace_settings: 'Workspace settings',
    why_this_field_required: 'Why is this field required?',
    webhooks: 'Webhooks',
    weekly: 'Weekly',
    biweekly: 'Biweekly',
    monthly: 'Monthly',
    entry_locked_by_approval: 'This entry has been already approved and therefore cannot be edited.',
    all_entries_older: 'All entries older than {0} are locked and can be edited only by admins.',
    all_dates_older: 'All dates older than {0} are locked and cannot be used to create new entries/timers.',
    date_locked_by_approval: 'This date is part of an approved period and cannot be used to create new entries/timers.',
    create_webhook: 'Create Webhook',
    edit_webhook: 'Edit Webhook',
    webhook_url: 'Webhook URL',
    webhook_secret: 'Webhook Secret',
    events: 'Events',
    webhook_logs: 'Webhook Logs',
    event: 'Event',
    payload: 'Payload',
    status: 'Status',
    delivered_at: 'Delivered At',
    attempts: 'Attempts',
    saved_successfully: 'Saved successfully',
    phases_updated: 'Phases updated successfully'
  },
  access_levels: {
    admin: 'Admin | Admins',
    owner: 'Owner | Owners',
    member: 'Member | Members',
    pm: 'PM | PMs',
    gm: 'GM | GMs',
    direct_manager: 'Direct Manager',
    all_managers: 'All Managers'
  },
  priorities: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },
  timeframe: {
    all_time: 'All time',
    custom: 'Custom',
    hours: 'Hours',
    never: 'Never',
    day: 'Day | Days',
    daily: 'daily',
    week: 'Week',
    weekly: 'weekly',
    month: 'Month',
    monthly: 'monthly',
    day_of_week: 'Day of week',
    day_of_month: 'Day of month',
    invalid_day: 'Invalid day',
    weekends: 'Weekends',
    time: 'Time',
    today: 'Today',
    yesterday: 'Yesterday',
    this_week: 'This week',
    this_month: 'This month',
    this_year: 'This year',
    last_week: 'Last week',
    last_month: 'Last month',
    last_7_days: 'Last 7 days',
    last_15_days: 'Last 15 days',
    last_30_days: 'Last 30 days',
    last_3_months: 'Last 3 months',
    last_6_months: 'Last 6 months',
    last_12_months: 'Last 12 months'
  },
  days: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  entries: {
    updated_entry: 'Entry updated',
    entry_copied: 'Entry copied.',
    to_filter_phases_select_project: 'To filter by phases you must select one single project'
  },
  timer: {
    pause: 'Pause',
    start: 'Start',
    save_as_an_entry: 'Save as an Entry',
    updated_last_timer: 'Timer updated',
    timer_paused: 'Timer paused',
    timer_started: 'Timer started',
    timer_saved_as_entry: 'Timer saved as an entry.'
  },
  suggestion: {
    accept: 'Accept',
    ignore: 'Ignore',
    suggestion_accepted: 'Suggestion accepted and saved as entry.',
    suggestion: 'No Suggestions | 1 Suggestion | {el} suggestions'
  },
  tasks: {
    assigned_to_me: 'Assigned to me'
  },
  roles: {
    accountant: 'Accountant',
    business_development_professional: 'Business Development Professional',
    business_owner_or_founder: 'Business Owner or Founder',
    customer_service_representative: 'Customer Service Representative',
    data_science_engineer: 'Data Science Engineer',
    designer: 'Designer',
    devOps_engineer: 'DevOps Engineer',
    facilities_manager: 'Facilities Manager',
    financial_advisor: 'Financial Advisor',
    fitness_coach: 'Fitness Coach',
    group_manager: 'Group Manager',
    gm: 'GM',
    health_professional: 'Health Professional',
    human_resources_professional: 'Human Resources Professional',
    information_technology_rofessional: 'Information Technology Professional',
    legal_professional: 'Legal Professional',
    marketer: 'Marketer',
    mechanical_engineer: 'Mechanical Engineer',
    office_manager: 'Office Manager',
    operations_professional: 'Operations Professional',
    pm: 'PM',
    personal_assistant: 'Personal Assistant',
    president_or_ceo: 'President or CEO',
    product_manager: 'Product Manager',
    project_manager: 'Project Manager',
    property_manager: 'Property Manager',
    public_relations_professional: 'Public Relations Professional',
    real_estate_agent: 'Real Estate Agent',
    recruiter: 'Recruiter',
    salesperson: 'Salesperson',
    school_administrator: 'School Administrator',
    software_engineer: 'Software Engineer',
    student: 'Student',
    teacher_or_professor: 'Teacher or Professor',
    web_engineer: 'Web Engineer',
    writer_or_editor: 'Writer or Editor',
    member: 'Member | Members',
    description: {
      admin: 'Admin',
      owner: 'Owner',
      member: 'Member | Members'
    }
  },
  industries: {
    marketing_communication: 'Marketing&Communication',
    software_development: 'Software&Development',
    media_entertainment: 'Media&Entertainment',
    business_consulting: 'Business Consulting',
    real_estate: 'Real Estate',
    education: 'Education',
    trasportation: 'Trasportation',
    law: 'Law',
    health: 'Health'
  },
  integrations: {
    asana: 'Asana',
    basecamp_2: 'Basecamp 2',
    basecamp_3: 'Basecamp 3',
    google_calendar: 'Google Calendar',
    teams: 'Teams',
    outlook: 'Outlook',
    outlook_calendar: 'Outlook Calendar',
    outlook_office_365: 'Outlook/Office 365 Calendar',
    planner: 'Planner',
    project: 'Project',
    power_bi: 'Power Bi',
    azure_devOps: 'Azure DevOps',
    to_do: 'To Do',
    gitHub: 'GitHub',
    workspace: 'Workspace',
    calendar: 'Calendar',
    jira: 'Jira',
    microsoft: 'Microsoft',
    ms_to_do: 'MS To Do',
    microsoft_to_do: 'Microsoft To Do',
    microsoft_teams_calls: 'Microsoft Teams Calls',
    ms_planner: 'MS Planner',
    link: 'Link',
    microsoft_planner: 'Microsoft Planner',
    google_workspace: 'Google Workspace',
    suggest_an_integration: 'Suggest an integration',
    your_daily_activity: 'Your daily activity'
  },
  phases: {
    social_media: 'Social media',
    blog: 'Blog',
    analytics: 'Analytics',
    bugfix: 'Bugfix',
    feature: 'Feature',
    design: 'Design',
    testing: 'Testing',
    meeting: 'Meeting',
    calls: 'Calls',
    accounting: 'Accounting',
    development: 'Development',
    support: 'Support'
  },
  files: {
    xlsx: 'XLSX',
    csv: 'CSV',
    pdf: 'PDF'
  },
  validation: {
    validData: 'Must contain a valid date',
    amount_grater_than: 'Amount must be greater than or equal to 0',
    amount_less_than: 'Amount must be less than unbilled amount',
    name_required: 'Name is required',
    give_report_a_name: 'Give the report a name to save it',
    task_name_required: 'Task name is required',
    min_length: 'Must be at least {length} characters'
  },
  tag_lists: {
    marketing: 'Marketing',
    seo: 'SEO',
    adv: 'ADV',
    social: 'Social',
    finance: 'Finance',
    budgeting: 'Budgeting',
    investing: 'Investing',
    design: 'Design',
    wireframes: 'Wireframes',
    ideas: 'Ideas',
    it: 'IT',
    bugfix: 'Bugfix',
    dev: 'Dev',
    training: 'Training',
    internal_communication: 'Internal communication',
    meeting: 'Meeting',
    calls: 'Calls',
    support: 'Support',
    complaints: 'Complaints',
    review: 'Review',
    issues: 'Issues',
    customer_service: 'Customer service',
    ticketing: 'Ticketing',
    chat: 'Chat',
    technical_support: 'Technical support',
    hr: 'HR',
    talent_acquisition: 'Talent acquisition',
    onboarding: 'Onboarding',
    payroll: 'Payroll'
  },
  components: {
    licenseNumberDialog: {
      title: 'Manage licenses',
      licenses: 'How many licenses would you like in your workspace?',
      decrease_licenses: 'In case you require fewer licenses than those included in your current plan, please {contact}.',
      contact: 'contact us',
      amount_due: 'Today, you will be charged {amount} {currency}, for {licenses} licences until the end of your subscription period.',
      next_renewal: 'On your next renewal, your {period} payment will be {amount} {currency}, for {licenses} licences.'
    },
    addUserDialog: {
      add_a_new_user: 'Add a new user',
      email_address: 'Email address',
      adding_secondary_user: 'Adding a secondary user will give you the possibility to quickly switch between users from the profile menu.',
      user_inactiv: 'This user has been logged out for inactivity.{br} Please reinsert your password.',
      already_logged_in: 'User is already logged in.',
      incorect_login: 'Incorrect login data.'
    },
    appDialog: {
      app: 'App',
      app_logo: 'App logo',
      app_created: 'App created.',
      app_saved: 'App saved.',
      app_name_between: 'An app name is required and must be between 3 and 256 characters.',
      app_website_url: 'App website URL',
      client_secret: 'Client secret',
      cancel_uri: 'Cancel URI *',
      developer_name: 'Developer name *',
      developer_name_between: 'The developer name is required and must be between 3 and 256 characters.',
      description_not_more_than: 'The description cannot be more than 512 characters.',
      max_upload_size: 'Maximum upload size 2M (jpg, jpeg, png, bmp, svg, webp)',
      privacy_policy: 'Privacy policy URL',
      redirect_uri: 'Redirect URI *',
      redirect_uri_required: 'The redirect uri is required.',
      terms_conditions_url: 'Terms & conditions URL',
      will_be_able_to_uploade: 'You will be able to upload your avatar after creating the app'
    },
    addPhasesDialog: {
      add_phases_to_projects: 'Add Phases to projects'
    },
    bulkEditExpensesDialog: {
      lock_selected_expenses: 'Lock selected expenses',
      unlock_selected_expenses: 'Unlock selected expenses',
      edit_multiple_expenses: 'Edit multiple expenses'
    },
    bulkEditProjectsDialog: {
      set_a_client: 'Set a client',
      edit_multiple_projects: 'Edit multiple projects'
    },
    bulkEditUsersDialog: {
      edit_multiple_users: 'Edit multiple users',
      set_manager: 'Assign manager'
    },
    clients: {
      search_clients: 'Search within clients',
      active_clients: 'Active clients',
      archived_clients: 'Archived clients',
      advise_archive: 'You are about to archive one client | You are about to archive {number} clients',
      advise_project: 'Every project attached to this client will be archived | Every project attached to those clients will be archived',
      new_client: 'New client',
      number_client_archived: '{number} client archived | {number} clients archived.',
      number_client_deleted: '{number} client deleted | {number} clients deleted.'
    },
    configurationMenu: {
      option_configurations: 'Options Configuration',
      actions_onfigurations: 'Actions Configuration',
      time: 'TIME',
      money: 'MONEY'
    },
    calendarConfigurationDialog: {
      calendars_could_not_be_fetched: 'Calendars could not be fetched. Please try again after authorizing your account again.',
      connected: 'Connected',
      you_have_linked_integration: 'You have linked your {name} with your {br}Timeneye workspace',
      it_might_take_minuts: 'It might take a few minutes before your {br} events appear on your dashboard',
      link_to_your_user: 'Link {name} to your user',
      back_to_dashboard: 'Back to dashboard',
      fetching_calendars: 'Fetching calendars...'
    },
    createPhaseDialog: {
      error_creating_phase: 'Error creating phase.',
      create_new_phase: 'Create a new phase',
      account: 'Account | Accounts',
      created_last_phase: 'Phase created'
    },
    copyPhaseCategoryDialog: {
      from_existing_project: 'From existing project',
      from_timeneye_preset: 'From Timeneye preset',
      marketing_preset: 'Marketing preset',
      developer_preset: 'Developer preset',
      sales_preset: 'Sales preset',
      customer_service_preset: 'Customer Service preset',
      select_present_for_phases: 'Select a present from which to copy the phases'
    },
    copyPhasesDialog: {
      filter_projects: 'Filter projects',
      copy_phases: 'Copy phases',
      management: 'Management'
    },
    clientDialog: {
      you_are_about_to_archive_name: 'You are about to archive {name}<br> Every project attached to this client will be archived',
      archiving_client: 'Archiving client',
      un_archiving_client: 'Un-archiving client',
      client_archived: 'Client archived',
      client_unarchived: 'Client unarchived',
      client_name_required: 'A client name is required',
      create_client: 'Create client',
      edit_client: 'Edit client',
      created_last_client: 'Client created',
      deleted_client: 'Client deleted',
      delete_clients: 'Delete clients',
      updated_last_client: 'Client updated'
    },
    clientArchiveDialog: {
      you_are_about_to_archive: 'You\'re about to archive'
    },
    clientsDeleteDialog: {
      entries_unlinked: {
        all_entries_going_to: 'ALL entries tracked on these clients {0}',
        unlinked_from_it: 'are going to be unlinked from it'
      },
      dont_want_to_lose_client: 'If you don\'t want to lose your data, we recommend archiving this client instead. | If you don\'t want to lose your data, we recommend archiving these clients instead.'
    },
    dashboard: {
      dashboard: 'Dashboard',
      another_member_calendar: 'You are viewing another member\'s calendar',
      timezone_alert: 'WARNING: Your current timezone is different from the one in your settings, {go_to_profile_settings}',
      go_to_profile_settings: 'please update it to avoid any issues.',
      go_to_profile_settings_tooltip: 'Go to profile settings',
      ignore_timezone_alert: 'Close',
      collapse: 'Collapse',
      loading_calendar: 'Loading calendar events...',
      loading_calendar_wait: 'Loading calendar events, this might take a while',
      linked_to_account: 'is linked to this account. Click here to learn more!',
      personal_budgets: 'Personal budgets',
      havent_budgets: 'You don\'t have any personal budgets.',
      havent_project_budgets: 'You don\'t have any budget assigned to your projects',
      how_crate_budget: 'How to create a budget',
      old_timers: 'You have one timer waiting to be saved as an entry | You have {timers_count} timers waiting to be saved as an entry',
      insights: 'Insights',
      client_recap: 'Client recap',
      link_ms_todo: 'Link MS Todo',
      manage_ms_todo: 'Manage MS Todo',
      clients_recap: 'Clients recap',
      projects_recap: 'Projects recap',
      phase_recap: 'Phase cat. recap',
      no_element_selected_time: 'You don\'t have entries on any {element} in the selected time frame.',
      time_recap: 'Time Recap',
      open_recap: 'Open the recap to see the workspace members\' last tracked time.',
      no_time_tracked: 'None of your team members have tracked any time.',
      recap: 'Recap',
      sort_tasks: 'Sort tasks',
      add_new_task: 'Add new Task',
      no_matching_filters: 'No tasks matching filters',
      link_ms_to_do: 'Link MS To Do',
      dont_show_this_anymore: 'Don\'t show this anymore',
      import_from_ms: 'Import from MS Planner',
      try_to_sync_again: 'Try to sync again',
      dont_show_this: 'Don\'t show this',
      locked_date: 'Locked date',
      not_your_calendar: 'Not your calendar',
      cant_track_time_for_other_members: 'You can\'t track time for other members using the calendar, use the register time button instead.',
      search_task: 'Search task',
      cannot_edit_other_member_entries: 'You cannot edit entries when looking at another member\'s calendar.',
      average_mood: 'Average mood',
      move: 'Drop here to \\A MOVE \\A in this day',
      copy: 'Drop here to \\A COPY \\A in this day',
      tag_list_recap: 'Tag lists recap',
      hold_shift: '(hold SHIFT to copy)',
      link_calendar: 'Link calendar',
      open_service_link: 'Open service link in a new tab',
      total_time_of_total_working_time: '{total_time} of {total_working_time}',
      no_suggestion: 'No suggestions',
      refresh: 'Refresh',
      update_bassed_on_teams_call_log: 'Update based on teams call log. (Original duration: {0})',
      actual_duration: 'Actual duration',
      timeline: 'Timeline',
      cards: 'Cards'
    },
    dialogs: {
      action_not_reversible: 'PLEASE NOTE: this action is not reversible.',
      element_delete: {
        any_element_will_be_deleted: 'Any data linked to these {element} will be immediately deleted and will {not} be possible to restore it.',
        not: 'not'
      },
      disabling_option: 'Disabling this option will not sync future private appointments, but will not delete already imported ones.',
      feedback: 'Feedback',
      hide: 'Hide',
      last_timer: 'Last timer',
      manage_phases: 'Manage Phases',
      no_matching_filters: 'No matching results for current filters',
      phase_name: 'Phase name',
      project_with_no_tags_edit: 'This project has no tags. Edit project settings to add tags.',
      users_invited: 'Users invited',
      ok: 'OK',
      select_projects: 'Select projects',
      selected_users: 'Selected users',
      set_expense_category: 'Set an expense category',
      workspace_access_level: 'Workspace access level'
    },
    dashboardSettingsDialog: {
      clients_recap: 'Clients recap',
      entity_notes: 'Entity notes',
      dont_show_any_module: 'Don\'t show any module',
      dashboard_settings_saved: 'Dashboard settings saved',
      modules_state: {
        modules: 'Modules:',
        modules_none: '{0} Hidden',
        modules_top_bar: '{0} Top bar',
        modules_bottom_bar: '{0} Bottom bar',
        modules_left_sidebar: '{0} Left sidebar',
        modules_right_sidebar: '{0} Right sidebar'
      },
      projects_recap: 'Projects recap',
      phase_categories_recap: 'Phase categories recap',
      dashboard_configuration: 'Dashboard configuration',
      bottom: 'Boottom',
      left: 'Left',
      right: 'Right',
      top: 'Top'
    },
    existingDomainDialog: {
      workspace_domain_exist: {
        looks_like_workspace_domain: 'It looks like a workspace with the domain {element} already exists'
      },
      probably_someone_has_workspace: 'Probably someone in your team has already created a workspace in timeneye.',
      please_wait_invitation: 'Please wait for an invitation email or contact {br} your account administrator.',
      ok_got_it: 'Ok, got it',
      create_workspace: {
        i_want_to: 'I want to continue and create a {0}',
        create_workspace: 'new workspace'
      },
      new_workspace: 'new workspace',
      sure_create_workspace: 'Are you sure that you want to create a new workspace?',
      keep_in_mind: 'Please keep in mind that',
      wont_be_able_join_workspace: 'You won\'t be able to join other workspaces',
      you_can_be_in_single_workspace: 'You can be part of a single workspace',
      join_workspace_invited: 'If you want to join an <strong>existing workspace</strong>, you need to get <strong>invited</strong>'
    },
    expenseCategoryDialog: {
      this_category_unit_price: 'This category has an unit price',
      expense_category_created: 'Expense category created',
      expense_category_name: 'Expense category name',
      edit_expense_name: 'Edit {expense_name}',
      unit_name: 'Unit name',
      unit_name_placeholder: 'e.g mile, copy'
    },
    expenseDialog: {
      you_are_deleting_expense: 'You are about to delete this expense<br/>This action requires confirmation',
      expense_created_successfuly: 'Expense created successfuly',
      quantity: 'Quantity',
      create_new_expense: 'Create new expense',
      expense_details: 'Expense details',
      deleted_expense: 'Expense deleted',
      edit_expense: 'Edit expense',
      member: 'Member | Members',
      updated_last_expenses: 'Expenses updated'
    },
    entries: {
      revenue: 'Revenue',
      x_more_tags: '+{el} more tags',
      hide_filters: 'Hide filters',
      show_filters: 'Show filters',
      number_entries_selected: '{number} selected.',
      your_activity: 'Your activity',
      advanced_filters: 'Advanced filters',
      notes_integration_info: 'Notes and integration info',
      x_items_selected: '{el} items selected',
      x_time_total: '{el} total',
      total: 'total',
      billed_status: 'Billed status',
      format: 'Format',
      delete_selected_items: 'Delete selected items',
      update_entries: 'Update entries',
      no_data_for_timeframe_filters: 'No data for the selected timeframe and filters.',
      run_entries_report: 'Run entries report',
      export_selected_entries: 'Export the selected entries',
      export_entries_filters: 'Export entries based on the applied filters',
      listed_out_of_total: '{el_number} listed out of {total_el} total',
      error_exporting_file: 'Error exporting {el}.',
      error_generating_pdf: 'An error occurred while generating the PDF',
      success_schedule_file_export: 'The export has been scheduled. You will shortly receive an email with the requested data.',
      delete_selected_entries: 'Delete selected entries',
      user_confirmation_dialog: "\n        You are about to update <strong>{sanitized_length}</strong> {element}<br />\n        Changes:<br />\n        <ul>\n        <li>{changes_length}</li>\n        </ul>\n      ",
      open_in_a_new_tab: 'Open in a new tab',
      ignore_suggestion: 'Ignore suggestion',
      unknown_project: 'Unknown project',
      to_file: 'to {file}',
      date_from_to_date_to: '{date_from} to {date_to}',
      any_state: 'Any state',
      no_changes: 'No changes',
      paused: 'Paused.',
      set_as_billable: 'Set as billable',
      set_as_billed: 'Set as billed',
      set_as_unbilled: 'Set as unbilled',
      set_as_not_billable: 'Set as not billable',
      set_owner: 'Set owner',
      set_project: 'Set project',
      set_phase: 'Set phase',
      set_date: 'Set date',
      set_billed_status: 'Set billed status',
      search: 'Search...',
      started: 'Started.',
      without_group: 'Without group',
      from_date_to_date: 'from {date_from} to {to_date}',
      entries_out_of_total: '{current_value} listed out of {totalEntries}',
      without_client: 'Without client',
      without_category: 'Without category',
      without_tag: 'Without tag',
      without_tag_list: 'Without tag list'
    },
    expenseCategories: {
      expense_category_deletion: 'Expense category deletion',
      category_deleted: 'Category deleted',
      category_state_archived: 'Category archived',
      category_state_unarchived: 'Category unarchived',
      category_cant_be_deleted: 'This category can\'t be deleted because there are expenses linked to it',
      curency_unit_price_per_unit_name: '{curency_symbol} {unit_price_first} per {unit_name_second}',
      active_categories: 'Active categories',
      deactivated_categories: 'Deactivated categories',
      new_expense_category: 'New expense category',
      you_are_deleting_expense_category: 'You are about to delete this expense category<br/><div class="text-body2 q-mt-sm">This action is non-reversible. If you don\'t want to lose your data, we recommend archiving this category instead.</div>'
    },
    expenses: {
      search_within_expenses: 'Search within expenses',
      set_billing_status_for_all_selected_expenses: 'Set billing status for all selected expenses',
      set_expense_category_for_all: 'Set expense category for all selected expenses',
      category_cannot_be_changed: 'Category cannot be changed for expenses with a set unit price.',
      lock_expenses: 'Lock Expenses',
      unlock_expenses: 'Unlock Expenses',
      locked: 'This expense cannot be edited',
      locked_by_approval: 'This expense is approved and therefore cannot be edited',
      dont_have_permision: 'Approved expenses cannot be edited',
      you_are_about_to_delete_expense: 'You are about to delete {el}.<br/> This action requires confirmation',
      this_expense: 'this expense',
      update_expenses_lock: 'Update expenses lock',
      you_are_about_change_the_billing_status_of_one_expense: 'You are about to change the billing status of <b>expense</b>.<br/> This action requires confirmation | You are about to change the billing status of <b>{number} expense</b>.<br/> This action requires confirmation',
      you_are_about_lock_one_expense: 'You are about to lock <b>expense</b>.<br/> This action requires confirmation | You are about to lock <b>{number} expenses</b>.<br/> This action requires confirmation',
      you_are_about_unlock_one_expense: 'You are about to unlock <b>expense</b>.<br/> This action requires confirmation | You are about to unlock <b>{number} expenses</b>.<br/> This action requires confirmation',
      you_are_about_edit_one_project: 'You are about to edit <b>project</b>.<br/> This action requires confirmation | You are about to edit <b>{number} projects</b>.<br/> This action requires confirmation',
      expense_deleted: '{number} expense deleted | {number} expenses deleted',
      expense_updated: '{number} expense updated | {number} expenses updated',
      any_projects: 'Any projects',
      any_members: 'Any members',
      any_expense_category: 'Any expense category',
      new_expense: 'New expense',
      set_expense_category: 'Set expense category',
      any_client: 'Any client',
      any_group: 'Any group'
    },
    attachments: {
      attachment: 'Attachment | Attachments',
      attach_file: 'Attach file',
      max_size: 'The maximum size is 50MB for images and 3MB for all other types of files.',
      download: 'Download',
      remove: 'Remove'
    },
    groups: {
      invalid_value: 'Invalid value',
      users_without_group: 'Users without group',
      invite_users: 'Invite users',
      invite_team_member: 'Invite team members',
      add_new_group: 'Add new group',
      edit_team_member: 'Edit team member',
      edit_group: 'Edit group'
    },
    groupDialog: {
      group_name: 'Group name',
      group_deleted: 'The group has been deleted',
      group_created: '{name} has been created',
      info: 'Info',
      new_group: 'New group',
      member: 'Member | Members'
    },
    groupAddUserDialog: {
      all_team_member_is_part_of_group: 'All your team members are already part of a group. Each team member can be only part of a single group.',
      add_member_to: 'Add member to {name}'
    },
    groupDeleteDialog: {
      any_user_will_be_removed: 'Every user in this group will be automatically removed from the linked projects.',
      group_deletion: 'Group deletion',
      delete_group: 'You\'re about to delete the \'{name}\' group.'
    },
    helpdesk: {
      watch_the_onboarding: 'Watch the Onboarding',
      product_guide_faq: 'Product guide & F.A.Q.',
      contact_our_support_team: 'Contact our support team',
      service_status: 'Service status',
      roadmap: 'Roadmap',
      webapp_dev: ' webapp v.3.01.21 - {br}- Developed by',
      dm_digital: 'DM Digital Software SRL',
      customize_layout: 'Customize the layout of your dashboard based on your preferences',
      you_can_set_timers_automatically: 'You can set your timers to automatically stop at a certain hour and send you an alert',
      track_manage_time: 'Track and manage your time inside your favourite webapps with our Chrome widget',
      can_export_entries: 'Did you know you can export your entries in CSV and PDF?',
      timeneye: 'Timeneye'
    },
    integration: {
      sync_status: 'Sync',
      integration: 'Integration',
      browser_widget: 'Browser Widget',
      our_browser: {
        supports: 'Our browser widget supports the {0}.',
        web_app: '{el} web app'
      },
      allows_track_time: 'It allows you to track your time directly on {el} without leaving their web app adding meaningful data to entries and timers.',
      chrome: 'Chrome',
      firefox: 'Firefox',
      edge: 'Edge',
      synchronization_settings: 'Synchronization settings',
      each_row_manages_a_syncronization: 'Each row in the table manages a syncronization feature.',
      you_can_enable_a_feature: 'You can enable a feature by clicking on the toggle button and enable the notifications regarding a feature by clicking on the bell icon.',
      refresh_authorization: 'Refresh authorization',
      unlink_name: 'Unlink {name}',
      link_name: 'Link {name} to your user',
      configuration: 'Configuration',
      integration_configurable_by_admin: 'This integration can only be configured by an admin user.',
      data_security: 'Data Security',
      requested_scopes: 'Requested Scopes',
      purpose: 'Purpose',
      privacy_and_security: 'Privacy and Security',
      timeneye_offers_seamless_integration_with_microsoft: "\n        Timeneye offers seamless integration with Microsoft services to enhance productivity and streamline task management.\n        When integrating Timeneye with Microsoft, certain permissions and data access are requested to ensure smooth functionality.\n        Below, we outline the permissions and data requested for MS Teams CALLS.",
      call_records_ead_all: 'CallRecords.Read.All: This scope allows Timeneye privileged access to callRecords for every call and online meeting within your organization including calls to and from external phone numbers.',
      with_these_permissions: 'With these permissions, Timeneye adjusts the duration of existing suggestions imported from Outlook, to match them to the calls done on them and imports any unscheduled call as new suggestions.',
      what_data_does_timeneye_access_and_why: 'What data does Timeneye access and why? Read the full article.',
      timeneye_respects_user_privacy: '{0} Timeneye respects user privacy and complies with data protection regulations.All data accessed from Microsoft services is handled securely and used solely for integration purposes.',
      timeneye_employs_secure_authentication_mechanisms: '{0} Timeneye employs secure authentication mechanisms to ensure that only authorized users can access Microsoft integrations.',
      any_data_transmitted_between: '{0} Any data transmitted between Timeneye and Microsoft services is encrypted to prevent unauthorized access.',
      data_protection: 'Data Protection',
      authentication: 'Authentication',
      data_encryption: 'Data Encryption',
      by_granting_permissions_users_can_enjoy_benefits: "\n        By granting these permissions, users can enjoy the full benefits of Timeneye's integration with Microsoft services,\n        enhancing productivity and task management efficiency while ensuring data security and privacy.\n        If you have any concerns or require further assistance, please don't hesitate to {0}",
      contact_support_team: 'contact our support team.'
    },
    integrations: {
      learn_more: 'Learn More',
      timeneye_browser_extension: 'Timeneye Browser Extension',
      install: 'Install',
      please_install_our_browser_extension: 'To see the time tracking controls inside your favourite tool, please install our browser extension.{br}This is how we appear in the interface. Make sure to install in any computer you use.',
      connect: 'Connect',
      guides: 'Guides',
      search_within_integrations: 'Search within our integrations'
    },
    inviteUsersDialog: {
      you_have_x_licenses: 'You have {element} licenses left.',
      owners_can_add_licenses: 'Only owners can add more licenses',
      remove_all_selected_users: 'Remove all selected users',
      add_to_recommended: 'Add to (recommended)',
      select_group: 'Select group',
      remove_user: 'Remove user',
      temmates_invited: 'Your teammates have been invited!',
      can_see_when_temmates_join_your_workspace: {
        can_see_when_temmates_join: 'You can see when your teammates will join {br} your workspace in the {team_section} or in {element}',
        team_section: 'Team section'
      },
      add_from_microsoft: 'Add from Microsoft',
      add_from_google_workspace: 'Add from Google Workspace',
      invite_new_team_members: 'Invite new team members',
      add_more: 'Add more',
      invite: 'Invite'
    },
    inviteUsersErrorsDialog: {
      proceed_to_dashboard: 'Proceed to dashboard',
      impossible_invite_some_users: 'Impossible to invite some users',
      fake_mail: "name@organization.com"
    },
    inviteUsersFromIntegrationDialog: {
      garant_permission: 'Grant {name} permission',
      available_users: 'Available users',
      select_all_visible_users: 'Select all visible users',
      error_retrieving_the_users_list: 'Something went wrong retrieving the users list from your account. Please make sure the chosen account is a company account.',
      authorization_refreshed: 'Authorization refreshed',
      retrieving_users: 'Retrieving users...',
      automatically_import_team_mebers: {
        automatically_import: 'Automatically {team_members} into Timeneye.{br}All you need to do is to grant us permission to access your {element} team members\' list.',
        team_members: 'import your team members'
      },
      search_by_name: 'Search by name {name}',
      search_by_name_or_email: 'Search by name or email',
      invite_users_from: 'Invite users from {name}',
      invite_team_by: {
        not_ready: 'Not ready to grant permission? {invite_by_email}',
        invite_by_email: 'Invite your team members by email'
      },
      something_went_wrong_retrieving_users: 'Something went wrong retrieving the users list from your account. Please make sure the chosen account is a company account.'
    },
    keyboardShortcutsDialog: {
      open_register_time: 'Open the "Register time" dialog',
      open_entries: 'Open the "Entries" dialog',
      open_timers: 'Open the "Timers" dialog'
    },
    management: {
      logout: 'Logout'
    },
    notifications: {
      no_notifications_available: 'No notifications available'
    },
    password: {
      at_least_8_character: 'At least 8 characters long',
      at_least_a_digit: 'At least a digit',
      at_least_a_capital_letter: 'At least a capital letter',
      at_least_a_special_character: 'At least a special character'
    },
    phases: {
      use_phases_to: {
        track_time: 'Use phases to keep track of your time in a more organized way. {0}',
        learn_more: 'Learn more'
      },
      project_phases_activities: '(Project phases/activities - i.e. Calls, Meeting, Accounting)',
      the_phase_activity_category: '(The phase/activity category. - i.e. Sales, Marketing, Development)',
      time_tracked: 'Time <br />tracked'
    },
    pickers: {
      all_element: 'All {el}',
      any_element: 'Any {el}',
      date_format: 'Date format',
      after_creating_new_entry_timer: 'After creating a new entry/timer',
      close_form: 'Close form',
      leave_form_open: 'Leave form open',
      primary_action: 'Primary action',
      interface_duration_format: 'Interface duration format',
      reports_tables_duration_format: 'Reports & tables duration format',
      first_day_of_week: 'First day of the week',
      field_saved_automatically: 'This field is saved automatically on change',
      deselect_all: 'Deselect all',
      no_element_found: 'No {el} found.',
      invite_member: 'Invite new member',
      search_within: 'Search within {el}',
      search_within_tags: 'Search within tags',
      new_row_named: '{el} named {input}',
      manage_tags: 'Manage Tags',
      requires_at_least_one_tag: 'The selected project requires at least one tag per entry',
      missing_tag_for_tag_list: 'Missing tag for required tag list',
      add_tags_to_tag_list: 'This tag list has no tags. Add a new one',
      select_one_or_more_type: 'Select one or more {el}',
      type_name: '{el} name',
      no_el: 'no {el}',
      date_from: 'Date from',
      date_to: 'Date to',
      create_new_element: 'Create new {el}',
      create_new_option: 'Create new option',
      create_new_task_list: 'Create new task list',
      create_new_tag_list: 'Create new tag list',
      no_selection: 'No selection',
      no_project_selected: 'No project selected',
      picker: 'Picker',
      option: 'Option | Options',
      appLanguage: {
        beta: 'Some languages are still in beta. If you find any issues, please let us know.'
      },
      description_non_billable: 'Work hours for which the client will not be billed (e.g. team meeting)',
      description_billable: 'Time entries that could be Unbilled or Billed',
      description_unbilled: 'Work hours for which the client will be charged.',
      description_billed: 'Hours worked that your company has already invoiced to clients.'
    },
    profile: {
      user_info: 'User info',
      app_settings: 'App settings',
      suggestion: 'Suggestion',
      your_preferences_updated: 'Your preferences have been updated',
      language: 'Language',
      language_help_us: 'Please note that our translations are still in beta, if you spot any incorrect translations or have suggestions for improvements, please let us know! You can contribute directly via {0}.',
      language_of_workspace: 'This is the language that will be used for your workspace.',
      number_formatting: 'Number formatting',
      select_your_language: 'Select your language to format numbers based on your country standards.',
      this_wont_affect_language: 'This settings won\'t affect the application language.',
      date_and_country: 'Date and country',
      country_and_timezone_settings: {
        settings: 'The {0} settings are used to show datetimes based on your location.',
        country_and_timezone: 'country and timezone'
      },
      chose_fisrts_day_of_week_and_format: {
        chose: 'Choose the {0} and {1} based on your preferences.',
        fisrts_day_of_week: 'first day of the week, weekend days',
        date_format: 'date format'
      },
      timeformats_are_used_for_entries: {
        are_used_for_entries: 'The {0} are used for the entries and timers hours in your calendar and reports.',
        timeformats: 'time formats'
      },
      auto_stop_timers: 'Auto stop timers',
      select_when_to_autostop: {
        select_when_to: 'Select the time of the day when Timeneye should automatically {0} your timers.',
        stop: 'stop'
      },
      hint_when_to_set_autostop: {
        when_to_set_autostop: '{0}: Set up the auto-save according to your office closing hour.',
        hint: 'Hint'
      },
      enable_autostop: 'Enable autostop',
      send_email: 'Send email',
      stop_timers_at: 'Stop timers at',
      register_time_form: 'Register time form',
      primary_action_will_switch_entries_timers: ' The primary action settings will switch the entries/timers buttons in the "Register time".{br}The keyboard shortcuts will change accordingly',
      whats_best_for_me: 'What\'s best for me?',
      if_you_have_entries: "If you insert entries only at the end of the day, you may be more\n      comfortable in setting \"Entry\" as primary action and leaving the\n      form open after creating time entries. If you track the time\n      on-the-go you may prefer to have \"Timer\" as primary action and to\n      have the form closed automatically.",
      if_you_have_large_number_of_projects: "If you have a large number of projects and clients you should\n      enable the client filter.{br} way you'll be able to filter\n      projects by client.",
      show_client_filter: 'Show client filter',
      speeds_time_by_crating_suggestion: {
        speeds_time: 'Timeneye speeds the time tracking experience by {0} based on your daily activity and the integrations.',
        creating_suggestions: 'creating suggestions'
      },
      all_sugestion_older_than_30: 'All the suggestions older than 30 days are deleted automatically.',
      new_to_timeneye: 'If you have just started using Timeneye, you may need to wait a couple of days before you can see the suggestions.',
      enable_old_suggestion_style: 'Enable old suggestion style',
      system_emails: 'System e-mails',
      system_emails_cannot_be_disabled_message: {
        message: "\n          {system_emails_cannot_be_disabled}\n          {br}They include user invitations, invoices,\n          billing/subscription alerts, data exports, workspace deletion,\n          security alerts and communications from your Account admins.",
        system_emails_cannot_be_disabled: 'System emails cannot be disabled'
      },
      onboarding_emails: 'Onboarding e-mails',
      emails_to_guide_trial: 'A series of emails to guide you through the trial period.',
      daily_reminder: 'Daily reminder',
      will_understand_how_many_hours: "After you've been using it for a while Timeneye will understand\n      how many hours a day you usually work. Enabling the daily reminder\n      will send you an email when you forget to track your time or if\n      you track less than usual.",
      weekly_status: 'Weekly status',
      recive_email_teamm_tracked: 'Receive a status report email to see what your team has tracked during the last week.',
      feature_avaiable_for_pm_admin: 'This feature is available for PMs and Admins.',
      automation_emails: 'Automation e-mails',
      enable_for_email_from_automations: 'Enable this option to be able to receive the e-mails from the automations, and be able to create automations regarding scheduled reports.',
      news_from_team: 'News from the team',
      recive_newsletter: 'Receive a newsletter to inform our users about the last released features and news about Timeneye.',
      will_send_newsletter_once_a_month: {
        will_send_newsletter: 'We will send the newsletter {0}',
        max_once_month: 'max once a month.'
      },
      api_updates: 'API updates',
      if_you_use_our_api: 'If you use our APIs we recommend to subscribe to this mailing-list.',
      daily_recap: 'Daily recap',
      daily_recap_description: 'Receive a daily recap of your tracked time.',
      expires_at: 'Expires at',
      revoke: 'Revoke',
      copy_token: 'Copy the following token to a secure place',
      you_wont_be_able_access: 'You won\'t be able to access this information in the future',
      issue_new_personal_tocken: 'Issue new personal access token',
      give_this_token_name: 'Give this token a mnemonic name',
      revoke_access_token: 'Revoke access token',
      are_you_sure_removing_token: 'Are you sure that you want to proceed revoking the token named <strong>{el}</strong>?<br/>All the application that are currently using it will lose their authentication session.',
      token_copied: 'Token copied to clipboard',
      listed_personal_token: 'Here are listed the personal access token issued for your user.',
      bearer_token_issued_by_personal_access: {
        bearer_token_issued: "The Bearer token issued by a personal access token can be used to authenticate to the APIs without creating an app from the developer portal.{br}{br}\n        To authenticate the requests, fill the \"Authorization\" HTTP header with {bearer_token}",
        bearer_token: '"Bearer <token>"'
      },
      personal_access_token_expire: {
        token_expire: 'Personal access tokens expire after {one_year} and can\'t be refreshed.{br}',
        one_year: 'one year'
      },
      please_visit_api: {
        please_visit: 'Please visit the {0} for more information',
        api_documentation: 'API documentation page'
      },
      authorized_apps: 'Authorized apps',
      listed_third_party_apps: 'Here are listed the third-party apps that you have authorized.',
      legacy_apps_are_scheduled: 'Legacy apps are scheduled to be deprecated at the end of 2024.',
      created_by: 'Created by',
      no_apps_authorized: 'No apps authorized',
      revoke_app: 'Revoke app',
      revoke_access_to_app: 'Are you sure you want to revoke your access to the app {el}?',
      access_to_app_revoked: 'The access to the app has been revoked.',
      avatar_visible_to_you_and_members_of_team: 'This avatar will be visible to you and the members of your team.',
      drop_image: 'Drop your image anywhere or click here to select from your device',
      max_image_size: 'Maximum upload size 2M (jpg, jpeg, png, bmp, svg, webp)',
      name_will_be_visible_to: 'Your name will be visible to any team members of the workspaces you\'re linked to based on the workspace configurations.',
      email_will_be_visible_to: 'Your email will be visible to any admin in the workspace you\'re linked to.',
      enter_new_email: 'Enter the your new email address.{br}You will receive an email with a confirmation code.',
      confirmation_code: 'Confirmation code',
      enter_the_code: 'Enter the code you received on the new email.{br}The code will expire after 10 minutes',
      change_password: 'Change password',
      keep_information_safe: 'To help keep your information safe your password should be at least 8 characters long and contain one digit and a special character',
      you_will_be_logged_out: 'Please note: If you change the password you will be logged out of any mobile session.',
      add_another_account: 'Add another Timeneye account so you can switch between the two from the top-right corner.',
      too_many_attempts: 'Too many attempts',
      token_name: 'Token name',
      third_party_apps: 'Third-party apps',
      day_picker_label_on: 'on',
      time_picker_label_at: 'at',
      actions: 'Actions',
      edit_email: 'Edit email',
      updated_last_email: 'Email updated',
      updated_last_password: 'Password updated'
    },
    project: {
      add_users_to_all_selected: 'Add users to all selected projects',
      you_have_been_flagged_as: 'You have been flagged as "{el}" of this project.',
      this_project_is_public: 'This project is public and automatically available to all {br} members of the workspace.',
      project_flagged_as_api: 'This project is flagged as API only. Any manual entry/timer on {br}this project is blocked.',
      project_linked_with: 'Project linked with {el}',
      all_active_projects: 'All active projects',
      all_archived_projects: 'All archived projects',
      my_active_projects: 'My active projects',
      my_archived_projects: 'My archived projects',
      sync_el_data: 'Sync {el} data',
      project_syncing: 'Project is syncing',
      edit_team: 'Edit team',
      edit_phases: 'Edit phases',
      edit_tags: 'Edit tags'
    },
    projectedit: {
      btn_bulk_edit: 'Bulk edit',
      group_name: 'Group {name}',
      remove_member_from_project: 'Remove member from project',
      no_user_linked_to_project: 'There are no users linked to this project',
      members_total_budget: 'Members total budget: ',
      project_budget: 'Project budget: ',
      demo_cannot_be_archived: 'Demo projects cannot be archived',
      duplicate_project: 'Duplicate project',
      project_is_archived: 'This project is archived',
      projects_is_api_only: 'This project is API only',
      project_is_public: 'This project is public',
      all_workspace_members: {
        part_of_project: 'All workspace members are part of this project and {may_not_be_added}.{br}Admins can change this setting under the \'Info\' tab.',
        may_not_be_added: 'may not be added nor removed from it'
      },
      last_edit_name_time: 'Last edited by {name} on {time}',
      project_duplicated: 'Project duplicated',
      add_my_group: 'Add my group',
      select_a_group: 'Select a group',
      remove_group_from_project: 'Remove group from project',
      no_group_linked: 'There are no groups linked to this project',
      select_group_to_add: 'Select a group to add',
      error_while_adding_group: 'Error while adding group',
      budget_recurrence: 'Budget recurrence',
      public_project: 'Public project',
      all_workspace_member_are_added: 'All workspace members are added to public projects. Only owners/admins can set projects as public.',
      is_billed_per_hour: 'Is billed per hour',
      task_management: 'Task management',
      enable_task_manager: "Enable task management for your project. You can always change this later. {br}\n      In case the project is linked to an integration, the tasks will be automatically imported from the integration. {br}\n      In case the integration does not support Tasks import, this section will not be available. {br}",
      enable_task_section: 'Enable task section',
      task_are_not_avvaiable: 'Tasks are not available for {el} projects at the given time.',
      api_lock: 'API lock',
      enable_the_api_look: 'Enable the API lock option if you want to block any manual entry/timer on this project.',
      it_may_be_useful: 'It may be useful for projects that need to be populated only by 3rd-party apps.',
      api_only: 'API only',
      only_admin_can_make_project_api_only: 'Only admins can make a project API only.',
      basic_info: 'Basic info',
      set_name_an_color: 'Set a name, a color and a description for your project.',
      this_phases_is_linked: 'The phase is linked with {el} and cannot be edited.',
      phase_linked_with: 'Phase linked with {el}',
      edit_tha_phase_name: 'Edit the phase name in {el}',
      there_are_no_phases_linked: 'There are no phases linked to this project',
      phases_total_budget: 'Phases total budget',
      the_integration: 'the integration',
      tags_provide_more_precise_description: "Tags provide a more precise description of your working time, serving as an additional method of categorization for complex projects.\n      Each time entry can be assigned one or multiple tags by the user.",
      enter_short_description: 'Enter a short description for the project',
      add_tags_to_project: 'Add tags to project',
      archived_last_project: 'Project archived',
      deleted_project: 'Project deleted',
      delete_phase: 'Delete phase',
      unarchived_last_project: 'Project unarchived',
      billing__and_budget: 'Billing & Budget',
      set_up_client_budget_hourlyrate: 'Set up a client, a budget, an hourly rate for your project or open the project to your whole team.',
      only_owner_can_update: 'Only owners can update the billing and budget on a non-billable project',
      users_total_budget: 'Users total budget'
    },
    projects: {
      search_within_projects: 'Search within projects',
      you_are_about_to_change_client_for_one_project: 'You are about to change client for <b>project</b>.<br/> This action requires confirmation | You are about to change client for <b>{number} projects</b>.<br/> This action requires confirmation',
      you_are_about_to_edit_one_project: 'You are about to edit <b>project</b>.<br/> This action requires confirmation | You are about to edit <b>{number} projects</b>.<br/> This action requires confirmation',
      you_are_about_to_add_element_into_project: 'You are about to add to {el} one <b>project</b>.<br/> This action requires confirmation | You are about to add to {el} one <b>{number} projects</b>.<br/> This action requires confirmation',
      api: 'API',
      add_users_to_all_projects: 'Add users to all selected projects',
      add_phases_to_all_projects: 'Add phases to all selected projects',
      add_groups_to_all_projects: 'Add groups to all selected projects',
      number_project_unchanged: 'One project unchanged. Demo projects cannot be archived. | {number} projects unchanged. Demo projects cannot be archived.',
      set_client: 'Set client',
      set_client_to_all_projects: 'Set client to all selected projects'
    },
    projectBudgetManagement: {
      only_owner_can_set_monetary_budget: 'Only owners can set a monetary budget for non-billable projects',
      for_non_billable_projects: 'For non-billable projects, the budget is accounted for the costs generated by the time entries.',
      also_have_option_set_hourly_rates_from_user: {
        also_have_option_set_hourly_rates: 'OPTIONAL: you also have the option to set hourly rates per each team member from the {0} tab.',
        user: 'User'
      },
      also_have_option_set_hourly_rates_from_member_section: 'OPTIONAL: you also have the option to set hourly rates per each team member from the Members section.',
      also_have_option_set_time_budgets_per_tag: 'OPTIONAL: You also have the option to set time budgets per <router-link to="#tags">Tag</router-link>, <router-link to="#users">User</router-link> or <router-link to="#phases">Phase</router-link> from the corresponding sections.',
      also_have_option_set_time_budgets_per: {
        also_have_option: 'OPTIONAL: You also have the option to set time budgets per {0}, {1} or {2} from the corresponding sections.',
        tag: 'Tag',
        user: 'User',
        phase: 'Phase'
      },
      also_have_option_set_time_budgets_from_corresponding_sections: 'OPTIONAL: You also have the option to set time budgets per Tag, Member or Phase from the corresponding sections.',
      budget_resets_every: 'Budget resets every',
      on_up_btn_budget_recurence_weekly: 'on',
      starting_from_up_btn_budget_recurence_monthly: 'on',
      send_email_alert: 'Send email alert if project exceeds',
      of_budget_after_input_alert_threshold: 'of budget',
      include_expense_in_budget: 'Include expenses in budget calculation',
      please_note_time_marked: {
        please_note_timers_marked: '{0} time entries marked as "not billable" will {1} be calculated in project budget.',
        time_entries_and_expenses_marked: '{0} time entries and expenses marked as "not billable" will {1} be calculated in project budget.',
        please_note: 'PLEASE NOTE:',
        not: 'not'
      }
    },
    pricingBillingCard: {
      upgrade_your_account: 'Upgrade your plan and get more features',
      select_best_plan: 'Select the best plan that responds to your team size and business goals',
      not_ready: {
        downgrade_to: 'Not ready yet? Downgrade to our {free_plan}',
        free_plan: 'Free Plan'
      },
      annual_billing: 'Annual billing',
      monthly_billing: 'Monthly billing',
      per_time: {},
      per_month: 'per user/month',
      billed_monthly: 'billed monthly',
      billed_yearly: 'billed yearly',
      custom_pricing: 'Custom pricing',
      up_to_limit_users: 'Up to {number} users',
      unlimited_users: 'Unlimited users',
      more_users: 'Need more users? {contact}',
      contact_us: 'Contact us',
      everything_in_plan: 'Everything in the {previous_plan} plan, plus',
      billing_platform: 'Billing platform',
      start_subscription_for: {
        you_are_about_to: 'You are about to start your subscription for the {pro}',
        pro_plan: 'Pro plan'
      },
      what_billing_prefer: 'What billing platform do you prefer?',
      microsoft_marketplace: 'Microsoft Marketplace',
      phurchase_subscription: 'Purchase your subscription on the Microsoft marketplace',
      start_subscription: 'Start your subscription',
      stripe: 'Stripe',
      use_your_credit_card: 'Use your credit card details to proceed with the payment',
      current_plan: 'Current plan',
      subscribe: 'Subscribe',
      talk_to_sales: 'Talk to Sales',
      upgrade: 'Upgrade',
      downgrade: 'Downgrade',
      try_plan: 'Try plan',
      you_want_to_switch: 'If you want to switch to the Free Plan, you must {archive_users} as the Free {br} Plan only includes 2 users.',
      you_want_to_downgrade: 'Would you like to downgrade to the Free Plan? {contact_us}',
      archive_number_users: 'archive {number} users',
      legacy_plan: 'This is now a Legacy Plan.',
      legacy_plan_description: 'All users on this plan will retain the features they are currently using.<br/>For a full list of the features in this plan, please refer to the table below. ',
      switch_to_free: 'Switch to Free Plan',
      successfully_switched_to_free: 'You have successfully switched to the Free Plan.'
    },
    projectDialog: {
      insert_project_name: 'Insert project name',
      project_name_required: 'A project name is required.',
      make_project_public: 'Make the project public',
      all_workspace_members_added_to_public_projects: 'All workspace members are added to public project',
      chose_members_to_add: 'Chose members to add',
      invite_new_users: 'Invite new users',
      press_enter_to_add_phase: 'press "enter" to add a new phase',
      created_project: 'Project created',
      general: 'General',
      project_details: 'Project details',
      member: 'Member | Members',
      project_type: 'Project type'
    },
    projectAddUserDialog: {
      add_team_members: 'Add team members',
      user_not_found: 'User not found',
      all_members_already_in_project: 'All your team members are already part of this project',
      search_user: 'Search user',
      to_name: 'to {name}'
    },
    projectArchiveDialog: {
      you_are_about_to_archive_x_projects: 'You\'re about to archive {num_project} projects',
      will_be_ignored: 'will be ignored. Demo projects cannot be archived.',
      archive_projects: 'Archive projects'
    },
    projectFromTemplateDialog: {
      template: 'Template',
      new_project_name: 'New project name'
    },
    projectUpdateWarningDialog: {
      attention_required: 'Attention required',
      deleting: 'Deleting',
      all_entries_in_phase: {
        will_be_deleted: 'PLEASE NOTE: ALL the entries in this {element} will be deleted {permanently}.{br}If you don\'t want to lose these entries, we recommend to move them to another phase before saving or to archive the {element} instead.',
        permanently: 'permanently'
      },
      removing: 'Removing',
      member_will_no_longer_track_time: 'This member will no longer be able to track time for this project but they will still be able to check their old entries on this project. | These members will no longer be able to track time for this project but they will still be able to check their old entries on this project.',
      all_members_of_group_no_longer_track_time_on_tag: 'Members will no longer be able to track time for this tag on this project. | Members will no longer be able to track time for those tags on this project.',
      sum_of_elements_exceeds_projects_budget: {
        sum_of_elements: 'The sum of your members/phases/tags budgets exceeds the project\'s budget.{br}{project_will_be_updated}',
        project_will_be_updated: 'The project\'s budget will be updated accordingly.'
      },
      confirm_and_save: 'Confirm and save'
    },
    projectsDeleteDialog: {
      entries_deleted: {
        all_entries_going_to: 'ALL entries tracked on these projects {0}.',
        deleted_from_it: 'are going to be deleted'
      },
      sugestion_and_timers_deleted: {
        all_timers_and_sugestion: 'ALL timers and suggestions currently linked to these projects {0}.',
        be_deleted: 'will be deleted'
      },
      dont_want_to_lose_project: 'If you don\'t want to lose your data, we recommend archiving this project instead. | If you don\'t want to lose your data, we recommend archiving these projects instead.',
      delete_projects: 'Delete projects'
    },
    projectsInvoiceDialog: {
      billed_money: 'Billed money',
      total_billable_amount: 'Total billable amount',
      billed_amount: 'Billed amount',
      unbilled_amount: 'Unbilled amount',
      there_are_invoice: 'There are no invoices for this project.',
      amount_updated: 'Amount updated'
    },
    phasesDialog: {
      serch_within_phases: 'Search within phases',
      manage_phases_dsa: 'Manage Phases'
    },
    phaseDialog: {
      with_name: 'with name {name}',
      set_all_elements: {
        set_all: 'Set all {0} as first line',
        categories: 'categories',
        names: 'names'
      },
      bulk_actions: 'Bulk Actions'
    },
    phaseCategoriesDialog: {
      phase_category_saved: 'Phase categories saved.',
      error_saving_phase: 'Error while saving phase categories.',
      missing_field_name: 'One or more fields are missing a name.',
      phase_category_name: 'Phase category name'
    },
    pickerDialog: {
      select_expense_category: 'Select an expense category',
      select_element: 'Select {el}'
    },
    report: {
      edit_report_name: 'Edit report name',
      report_scheduled: 'Report scheduled. Next run: {el}',
      rounding: 'Rounding',
      round_mode: 'Round mode',
      round_minutes: 'Round minutes',
      round_to_up_to: 'Round to up to',
      round_to_nearest: 'Round to nearest',
      round_to_down_to: 'Round to down to',
      x_minutes: '{el} minute | {el} minutes',
      x_hour: '{el} hour | {el} hours',
      type_report: '{type_report} report',
      some_data_has_changed: 'Some data has changed from last report generation',
      generete_pdf_error: 'An error occurred while generating the PDF',
      genereting_file: 'Generating {el}...',
      as_type_file: 'as {element} file',
      group_by: 'Group by',
      breakdown_by: 'Breakdown by',
      ungrouped: 'Ungrouped',
      untagged: 'Untagged',
      uncategorized: 'Uncategorized',
      no_todo: 'No todo',
      no_client: 'No client',
      to_open_entries_log: 'To open entries log on a phase you must filter for a single project',
      visible_data: 'Visible data',
      recurence_resets: {
        resets: '{recurence} resets on {element}',
        recurence: 'Recurrence:'
      },
      open_timesheet_dialog: 'Open in timesheet dialog',
      billed_amount: 'Billed amount',
      unbilled_amount: 'Unbilled amount',
      your_roi: {
        your_roi_is: 'Congratulations! Your ROI is {your_roi}% (ROI = (billed money - total costs) / total costs x 100)',
        your_current_roi_is: " Your current ROI is {your_roi}% (ROI = (total billed - total costs) / total costs x 100){br}\n        Your {estimated} ROI is {estimate_roi}% (billed money + unbilled money - total costs) / total costs x 100)",
        negative_current_roi: "Your current ROI is {your_roi}% (ROI = (total billed - total costs) / total costs x 100){br}\n        Your {estimated} ROI is {estimate_roi}% (billed money + unbilled money - total costs) / total costs x 100)",
        estimated: 'Estimated'
      },
      open_expenses_page: 'Open expenses page',
      internal_costs: 'Internal costs',
      column_disabled_because_no_budget: 'This column is disabled because the project has no budget. Edit the project to add a budget',
      project_not_billable: 'The selected project is not billable',
      single: 'Single',
      cumulative: 'Cumulative',
      expand_to_see_budgets: 'Expand to see budgets',
      your_subscription_dosnt_support: 'Your current subscription does not support project management',
      duplicate: 'Duplicate',
      effort: 'Effort',
      metric: 'Metric',
      new_type_report: 'New {type} report',
      no_data_for_curent: 'No data for{br}current period',
      schedule: 'Schedule',
      save_report: 'Save report',
      from_date_to_date: '<span style="font-size: 10px">from</span> {date_from} <span style="font-size: 10px">to</span> {to_date}',
      total_expenses: 'Total expenses',
      last_version_support: {
        historical: "The latest version of Timeneye supports historical rates.{0}\n          Therefore, financial information in reports from the legacy version may differ from the new version.{0}{1}",
        learn_more: 'Learn more'
      },
      error_while_generating_csv: 'An error occurred while generating the CSV'
    },
    reports: {
      templates_gallery: 'Templates gallery',
      recent_reports: 'Recent reports',
      scheduled: 'Scheduled',
      next_run: 'Next run',
      create_new_report_from: 'Create new report from scratch',
      monitor_your_project: 'Monitor your projects and stay within budget',
      get_real_time_insights: 'Get real-time insights about your team\'s effort',
      bill_accurately: 'Bill accurately and deliver on time',
      keep_track_of_billable: 'Keep track of billable and non-billable hours',
      dive_deeper: 'Dive deeper into your data with a tag report',
      blank: 'Blank',
      deleted_report: 'Report deleted'
    },
    estimateLogDialog: {
      title: 'Estimate log',
      no_log_entries: 'No log entries found.',
      log_entry: 'At {time}, {name} {action} the task estimate:',
      created: 'created',
      updated: 'updated',
      edit_task: 'Edit task'
    },
    recurrenceSuggestionDeleteDialog: {
      remove_only_this_occurrence: 'Remove only this occurrence',
      disable_recurrent_event: 'Disable this recurrent event',
      ignore_recurrent_event: 'Ignore recurrent event'
    },
    registerTimeDialog: {
      select_task: 'Select a task',
      entry_created: 'Entry created',
      update_entry: 'Update Entry',
      update_timer: 'Update Timer',
      open_link: 'open link',
      can_edit_locked_entry: 'Given your role, you can edit this entry',
      edit_entry: 'Edit entry',
      new_version: 'New version'
    },
    setup: {
      welcome_to_timeneye: 'Welcome to Timeneye!',
      you_have_been_invited: 'You have been invited to join',
      insert__full_name: 'Insert your full name',
      min_length_name: 'Your full name must be at least 3 characters',
      timeneye_will_monitor_your_progress: 'Timeneye will help you monitor your progress, stay within budget and visualize your daily effort',
      name_your_workspace: 'Name your workspace',
      min_length_company_name: 'The company name must be at least 3 characters',
      your_primary_role: 'What\'s your primary role?',
      tailor_your_workspace: 'This will help us to tailor your workspace based on your needs',
      choose_an_option: 'Choose an option',
      please_choose_option: 'Please choose an option',
      how_many_people_working: 'How many people will you be working with?',
      only_me: 'Only me',
      do_you_use_these_apps: 'Do you use any of these apps?',
      timeneye_can_integrate_with_tool: 'Timeneye can seamlessly integrate with your favorite tool',
      remove_suggestion: 'Remove suggestion',
      connect_microsoft: 'Connect your Microsoft account with Timeneye',
      this_will_let_you: 'This will let you',
      setting_up_your_workspace: 'Setting up your workspace',
      redirect_in_dashboard: 'You will be redirected in dashboard shortly',
      next: 'Next',
      grant_permissions: 'Grant permissions',
      bring_calendar_events: 'Bring your calendar events into your Timeneye dashboard to effortlessly track time for your daily meetings and events.',
      sync_your_to_do: 'Sync your To Do list with Timeneye to track time on your work tasks and stay organized',
      import_ms_planner: 'Import your MS Planner projects into Timeneye and seamlessly track your work tasks and monitor your progress',
      inser_name_of_company: 'Insert the name of your company',
      owner_has_set_planner: 'The account owner has set up MS Planner integration, and you have been included automatically. Therefore, it is important to keep this option enabled.',
      disabling_option: 'By disabling this option you will lose the ability to track time on projects imported from MS Planner to Timeneye by the account owner.',
      leave_your_mobile_phone: 'Leave your mobile number for onboarding support',
      insert_phone: 'Insert your phone',
      job_title_placeholder: 'E.g. Project Manager, Developer, CTO',
      workspace_creation: 'Workspace creation',
      invite_team_to_timeneye: 'Invite your team to Timeneye',
      garant_permission: 'Grant permission',
      install_browser_widgt: 'Install the Timeneye Browser Widget',
      install: 'Install',
      timeneye_browser: {
        embed_time_tracking: "The Timeneye Browser Widget enables you to embed time tracking controls within the interface of your preferred Microsoft software, such as {integrations}.{br}\n        This makes it even easier for you and your team to fill the timesheet accurately.",
        integrations: 'MS Planner, MS To Do, or Jira'
      },
      import_team_into_timeneye: 'Import your team members into Timeneye.{br}All you need to do is to grant us permission to access your Microsoft team members\' list.',
      skip: 'Skip',
      number_users: '0 users selected|1 user selected|{number} users selected',
      back: 'Back'
    },
    listableUsersFromIntegration: {
      invite_users_from_provider: 'Invite users from {provider}'
    },
    scheduleReportDialog: {
      schedule_report: 'Schedule report',
      report_name: 'Report name',
      schedule_every: 'Schedule every',
      save_schedule: 'Save schedule',
      invalid_email_adress: 'Invalid email address',
      email_already_exist: 'This email address already exists.',
      press_add_or_enter: 'Press "Add" or "Enter" to insert this email address to the recipients',
      max_10_mails: 'Max 10 emails allowed.',
      send_email_to: 'Send an email to',
      share_report: {
        you_can_share: "You can share this report with up to {with_10} {br}\n        Once their email addresses are verified, they will receive this report regularly.",
        with_10: '10 people.'
      },
      only_me: 'Only me',
      me_others: 'Me & others',
      share_with: 'Share report with',
      recipient_maximum_warning: {
        to_add_you_have_to_remove: '{0} To add more recipients, you have to remove some.',
        recipient_maximum_capacity: 'Your recipient list is at maximum capacity.'
      },
      recipients: 'Recipients',
      remove_from_recipients: 'Remove member from recipients',
      confirmed: 'Confirmed',
      pending: 'Pending',
      choosing_this: {
        all_mail_will_be_removed: '{0} By choosing this option, all previously entered email recipients will be removed from the list, and they will not receive your report.',
        warning: 'Warning'
      }
    },
    sharedEmailDialog: {
      you_have_added_x_pepople: 'You have added {number} people to your recipients',
      when_email: {
        verified: "Once their email addresses are verified, they will receive this report regularly. {br}\n          This report is shared with a {total_of_recipients}",
        total_of_recipients: 'total of {totalRecipientsCount} recipients.'
      }
    },
    subscriptionTypeUpgrade: {
      upgrade_to: 'This feature is included in the ',
      free: 'Free Plan',
      starter: 'Starter Plan',
      premium: 'Premium Plan',
      enterprise: 'Enterprise Plan',
      not_owner_message: 'To gain access to this feature, you need to ask the workspace Owner to upgrade the subscription plan.',
      not_owner: 'Need Owner approval'
    },
    suggestionsDialog: {
      sugestion_for: 'Suggestions for',
      suggestions_ignored: 'Suggestions ignored',
      problem_ignoring_suggestions: 'There was a problem ignoring one or multiple suggestions',
      ignore_all: 'Ignore all'
    },
    suggestIntegrationDialog: {
      always_open_to_suggestions: 'Here at Timeneye we are always open to suggestions in order to improve our tool.',
      write_name_of_software: 'Please write the name of the software you would like us to integrate with',
      please_write_name: 'Please write the name.',
      send: 'Send'
    },
    switchEnvironmentDialog: {
      new_version: {
        rewritten: "The legacy version of Timeneye will be discontinued starting from December 31st, 2024. {br}\n              If you are experiencing blocking issues, please make sure to contact us using the {support_chat}",
        support_chat: 'support chat'
      },
      let_us_know_why_old_version: 'Please let us know why you prefer the old version. The more detailed your feedback, the better we can improve our product and meet your needs.',
      prefer_old_version: 'I prefer the old Timeneye version because...',
      switch_old_version: 'Switch back to the old version'
    },
    switchUserDialog: {
      switch_user: 'Switch user'
    },
    tagManagement: {
      select_tag_list: 'Select tag list',
      unarchive_this_tag_list: 'Unarchive this tag list to select it',
      create_a_tag: 'Create a tag to select this tag list',
      create_or_unarchive: 'Create a tag or unarchive a tag to select it',
      create_without_adding: 'Create without adding',
      tag_list_already_linked: 'This tag list is already linked to {el} projects. </br> Do you want to add this tag to all linked projects?',
      add_tag_to_linked_projects: 'Add tag to linked projects',
      search_within_tag_lists_tags: 'Search within tag lists & tags',
      show_archived_tag_lists_tags: 'Show archived tag & tag lists',
      choose_from_preset: 'Choose from preset',
      select_all_lag_list_tag: 'Select all visible tag lists and tags',
      no_tag_list_matching: 'There are no tag lists matching filters.',
      tags_total_budget: 'Tags total budget',
      there_are_no_active_tag: 'There are no active tag lists in your workspace yet.',
      add_a_new_one: 'Add a new one',
      open_in_timesheet: 'Open in Timesheet',
      add_new_tag_list: 'Add new tag list',
      add_new_tag: 'Add new tag',
      add_tag_to_projects: 'Add tag to projects',
      archived_last_tag_list: 'Tag list archived',
      archived_last_tag: 'Tag archived',
      archive_tag_list: 'Archive tag list',
      archive_tag: 'Archive tag',
      created_last_tag_list: 'Tag list created',
      created_last_tag: 'Tag created',
      delete_tag_list: 'Delete tag list',
      delete_tag: 'Delete tag',
      delete_confirmation_tag_list: 'Do you want to delete this tag list?',
      delete_confirmation_tag: 'Do you want to delete this tag?',
      edit_tag: 'Edit tag',
      remove_tag_list: 'Remove tag list',
      remove_tag: 'Remove tag',
      remove_tag_list_from_project: 'Remove tag list from project',
      remove_tag_from_project: 'Remove tag from project',
      reset_changes: 'Reset changes',
      unarchive_tag_list: 'Unarchive tag list',
      unarchive_tag: 'Unarchive tag',
      updated_last_tag_list: 'Tag list updated',
      updated_last_tag: 'Tag updated',
      unarchived_last_tag_lsit: 'Tag list unarchived',
      unarchived_last_tag: 'Tag unarchived',
      save_tag_list: 'Save tag list',
      save_tag: 'Save tag',
      tag_list_confirmation_delete: 'After confirmation every entry associated to tags in this tag list will be untagged.',
      tag_confirmation_delete: 'After confirmation every entry associated to this tag will be untagged.',
      unarchive_this_tag: 'Unarchive this tag to select it'
    },
    tasks: {
      browser_extension: 'Browser extension'
    },
    timers: {
      paused_timers: {
        dont_have_active_paused_timers: 'You do not have any active or paused timers.{br}{click_here}',
        click_here: 'Click here to start a new one.'
      },
      dont_have_active_or_paused_timers: 'You don\'t have any active or paused timers'
    },
    todoManagement: {
      sync_data: 'Sync data',
      integration_syncing: 'Integration is syncing',
      todo_list_name: 'Todo List name',
      mark_not_completed: 'Mark as not completed',
      mark_as_completed: 'Mark as completed',
      set_due_date: 'Set a due date',
      task_removed: 'Task removed',
      rename: 'Rename',
      completed_tasks: 'Completed tasks',
      search_within_tasks: 'Search within tasks',
      add_new_task_list: 'Add new task list',
      create_new_task: 'Create new task'
    },
    tagListDialog: {
      tag_list_name: 'Tag list name',
      text_color: 'Text color',
      tag_name: 'Tag name',
      tag_list_created: '{name} has been created',
      add_tag_list: 'Add tag list | Add tag lists',
      default: 'Default'
    },
    tagListDeleteDialog: {
      all_tags: {
        going_to_be_deleted: 'ALL tags within this list will be immediately deleted and it will {0} be possible to restore them.',
        not: 'not'
      },
      tag_list_deletion: 'Tag list deletion',
      you_are_about_to_delete_taglist: 'You\'re about to delete this tag list.',
      taglist_deleted: 'The tag list has been deleted'
    },
    tagListPresentsDialog: {
      tag_list_presets: 'Tag List Presets',
      select_one_of_our_presents: 'Select one of our presets to kickstart your workspace.',
      tag_list_with_same_name_already_exist: 'A tag list with the same name is already present in your workspace',
      copy_to_workspace: 'Copy to workspace'
    },
    tagDeleteDialog: {
      tag_deletion: 'Tag deletion'
    },
    tagsDialog: {
      add_selected_tags_to_project: 'Add selected tags to project'
    },
    todoDialog: {
      to_edit_go_back_to_integration: 'To make changes to this task, please navigate back to {integration} and edit it from there. {br} Any modifications you make will be automatically synced with Timeneye',
      open_in: 'Open in {name}',
      assign_to: 'Assign to',
      select_todo_list: 'Select a todo list',
      task_list_required: 'A task list is required',
      insert_start_date: 'Insert start date',
      insert_due_date: 'Insert due date',
      insert_task_name: 'Insert task name',
      show_estimate_log: 'Show log',
      manage_task: 'Manage Task',
      deleted_task: 'Task deleted'
    },
    timersDialog: {
      save_all_as_entries: 'Save all as Entries',
      timers_saved: 'Timers saved',
      problem_occured_while_saving: 'A problem occurred while saving your timers'
    },
    users: {
      invite_from_microsoft: 'Invite from Microsoft',
      invite_from_google_workspace: 'Invite from Google Workspace',
      invite_by_email: 'Invite by E-mail',
      pending: 'Pending',
      resend_invite: 'Resend Invite',
      user_invited_less_than_a_day: 'This user has been invited less than 24 hours ago',
      export: 'Export',
      set_members_working_time: 'Set members working time',
      set_members_hourly_rate: 'Set members hourly rate',
      set_members_hourly_cost: 'Set members hourly cost',
      set_manager: 'Set manager',
      invite_sent: 'Invite sent',
      error_deactivating_user: 'Error while deactivating user',
      users_activated: 'Users activated',
      error_activating_user: 'Error while activating user.',
      user_in_your_workspace: 'The user is already member in your workspace',
      user_in_other_workspace: 'The user is already member in another workspace',
      user_already_selected_for_invite: 'The user is already selected for invite',
      dep: ' - Dep: {el}',
      search_within_users: 'Search within members',
      every: 'Every',
      invited_on: 'Invited on',
      never: 'Never',
      last_seen_on: 'Last seen on',
      last_entry_on: 'Last entry on',
      gm_explain: {
        explain: '{gm} can create projects, perform {br}management functions, and run reports, but only {br}for the groups under their management.',
        gm: 'Group Manager'
      },
      pm_explain: {
        explain: '{pm} can perform management {br}functions and run reports, but only for the active {br}projects under their supervision.',
        pm: 'Project Manager'
      },
      info_menu_roles: {
        info_owners: '{owners} have access to basically all the functions {br} and views, including managing the payment and {br} subscription and deleting the whole workspace.{br}',
        info_admins: '{admins} have all the Owner {br} functions except managing the payment and {br} subscription and deleting the workspace. {br}',
        info_members: '{members} can track time and edit their personal {br} settings and  integrations.{br}',
        owners: 'Owners',
        admins: 'Admins',
        members: 'Members'
      },
      info_menu_manager: {
        info_menu: 'The manager will be able to see this users\' time and expenses.{br} {learn_more}',
        info_menu_approval: 'The manager will be able to approve or reject the {br} timesheets and expenses of this user.{br} {learn_more}',
        learn_more: 'Learn more'
      },
      info_menu_hourly_rate: {
        info_menu: 'The rate you bill clients for this person\'s time.{br} {learn_more}',
        learn_more: 'Learn more'
      },
      info_menu_hourly_cost: {
        info_menu: 'The internal cost that this person incurs on your business.{br} {learn_more}',
        learn_more: 'Learn more'
      },
      you_are_about_to_change_element_to_user: 'You are about to change the {element} to <b>user</b>.<br/> This action requires confirmation | You are about to change the {element} to <b>{number} user</b>.<br/> This action requires confirmation',
      you_are_about_to_add_user_to_project: 'You are about to add <b>user to projects</b>.<br/> This action requires confirmation | You are about to add <b>{number} users to projects</b>.<br/> This action requires confirmation',
      you_are_about_to_set_manager: 'You are about to <b>set the manager to 1 user</b>.<br/> This action requires confirmation | You are about to <b>set the manager to {number} users</b>.<br/> This action requires confirmation',
      you_are_about_to_remove_manager: 'You are about to <b>remove the manager from 1 user</b>.<br/> This action requires confirmation | You are about to <b>remove the manager from {number} users</b>.<br/> This action requires confirmation',
      active_members: 'Active members',
      deactivated_members: 'Deactivated members',
      set_working_time: 'Set working hours',
      set_working_time_to_all_users: 'Set working hours for all selected users',
      set_hourly_rate_to_all_users: 'Set hourly rate to all selected users',
      set_hourly_cost_to_all_users: 'Set hourly cost to all selected users',
      set_manager_toltip: 'Assign a manager to all selected users'
    },
    userDialog: {
      add_new_user: 'Add new user',
      last_seen: 'Last seen',
      never_logged_in: 'Never logged in',
      is_part_of_group: 'Is part of group',
      group_managers_cant_be_demoted: 'Group managers can\'t be demoted from project managers if their group is in the project',
      error_deactiving_user: 'Error deactivating user.',
      user_activated: 'User activated.',
      error_activating_user: 'Error activating user.',
      error_deleting_user: 'Error deleting user.',
      changes_needs_saving: 'Changes needs saving',
      activate: 'Activate',
      deleted_user: 'User deleted',
      edit_user: 'Edit user',
      select_manager: 'Select manager for user'
    },
    userDeleteDialog: {
      all_entries: {
        all_entries_on_user: 'ALL entries tracked by the user {0}.',
        going_to_be_deleted: 'are going to be deleted'
      },
      all_data: {
        going_to_be_deleted: 'Any data linked to the user will be immediately deleted and it will {0} be possible to restore it.',
        not: 'not'
      },
      dont_want_to_lose_user: 'If you don\'t want to lose your data, we recommend archiving this user instead. | If you don\'t want to lose your data, we recommend archiving these users instead.',
      user_deletion: 'User deletion'
    },
    userActivationDialog: {
      you_are_about_to_activate: 'You\'re about to activate',
      you_are_about_to_deactivate: 'You\'re about to deactivate',
      user_deactivation: 'User deactivation',
      user_activation: 'User activation',
      user_name: '{name} | {number} users'
    },
    approvals: {
      title: 'Approval requests',
      description: 'Your team can submit their timesheets and expenses for review, which you can approve or reject.',
      approval_period: 'Approval period',
      workweek_begin: 'Workweek begins on',
      edit_recurrence_start_tooltip: 'Edit period recurrence date',
      manager_tooltip: 'All Managers include Direct managers and all managers up the management tree',
      direct_manager_tooltip: 'Direct Managers  are users responsible for the people directly under them',
      minimum_role: 'Who can approve expenses and timesheets',
      notification_role: 'Who can receive the notifications',
      recurrence_start: 'Recurrence period begin',
      recurrence_start_option: {
        previous_week: 'Previous week',
        this_week: 'This week',
        next_week: 'Next week',
        previous_month: 'Previous month',
        this_month: 'This month',
        next_month: 'Next month'
      },
      reminders: 'Set reminders',
      send_reminder_after_period_ends: 'Remind everyone to submit their timesheet and expenses {select} after approval period ends at {time}.',
      auto_submit_after_period_ends: 'Automatically submit previous period timesheet and expenses {select} after approval period ends.',
      auto_approve_after_period_ends: 'Automatically approve submitted timesheet and expenses {select} after approval period ends.',
      select_members: 'Select members',
      no_pending_requests: 'There are no pending approval requests',
      no_unsubmitted_requests: 'There are no unsubmitted approval requests',
      no_approved_requests: 'There are no approved approval requests',
      send_email_reminder: 'Send approval request reminder',
      send_email_reminder_message: 'You are about to send an email reminder to 1 user | You are about to send an email reminder to {usersCount} users',
      email_reminder_sent: 'Email reminder sent',
      status: {
        pending_approval: 'Pending approval',
        approved: 'Approved',
        submitted: 'Submitted',
        unsubmitted: 'Unsubmitted',
        rejected: 'Rejected',
        withdrawn: 'Withdrawn',
        action_required: 'Action required'
      },
      action: {
        send_reminder: 'Send email reminder',
        submit: 'Submit',
        submit_for_approval: 'Submit for approval',
        resubmit_for_approval: 'Resubmit for approval',
        approve: 'Approve',
        approve_all: 'Approve all requests',
        reject: 'Reject',
        withdraw: 'Withdraw'
      },
      tab: {
        pending: 'Pending',
        unsubmitted: 'Unsubmitted',
        approved: 'Approved'
      },
      timeline: {
        title_message: '{action} on {date} by {user_name}',
        view_full_history: 'View full history',
        without_notes: 'without notes'
      },
      user_name_timesheet: '{user_name}\'s timesheet',
      totalsWidget: {
        total_time: 'Total time',
        approved: 'Approved',
        billable: 'Billable',
        amount: 'Amount',
        expenses: 'Expenses'
      },
      select_project: 'Select project',
      remove_project: 'Remove project'
    },
    approvalsDialog: {
      title: 'Confirm approval request',
      reject_title: 'Reject approval request',
      withdraw_title: 'Withdraw approval request',
      approve_title: 'Approve timesheet and expenses',
      approve_all_title: 'Approve all timesheets and expenses',
      timesheet_submitted: 'Timesheet submitted for approval',
      timesheet_resubmitted: 'Timesheet resubmitted for approval',
      timesheet_and_expenses_submitted: 'Timesheet and expenses submitted for approval',
      timesheet_and_expenses_resubmitted: 'Timesheet and expenses resubmitted for approval',
      submit_title: 'Submit for approval',
      submit_description: 'Ready to submit {0} for approval?',
      approve_description: 'Once approved, the time will be locked and the timesheet will be moved in the Approved tab',
      time: 'Time:',
      expenses: 'Expenses:',
      add_note: 'Add a note',
      request_updated: 'Approval request updated'
    },
    approvalTimelineDialog: {
      title: 'Submission history'
    },
    workingHours: {
      default: 'Default working hours',
      reset_default: 'Restore account working hours',
      weekly_total: 'Weekly total:'
    },
    workingHoursReminder: {
      reminders_additiona_settings: 'Reminders and additional settings',
      send_reminder_email_team: 'Send an email reminder to anyone who tracked less than',
      send_reminder_email_user: 'Send an email reminder to this user if they tracked less than',
      of_their: 'of their',
      capacity: 'capacity',
      capacity_on: 'capacity on',
      capacity_on_month: 'capacity on the last day of the month',
      at: 'at',
      weekly_capacity: 'E.g.: If a user has a weekly capacity of 40 hours and tracks less than 32 hours, they will receive an email reminder.',
      daily_capacity: 'E.g.: If a user has a daily capacity of 8 hours and tracks less than 6,4 hours, they will receive an email reminder.',
      monthly_capacity: 'E.g.: If a user has a monthly capacity of 160 hours and tracks less than 128 hours, they will receive an email reminder at the end of the month.',
      default_reminder_settings: 'Default reminder settings'
    },
    workspaceSettings: {
      general_settings: 'General settings',
      security: 'Security',
      features: 'Features',
      workspace_settings_saved: 'Workspace settings saved',
      chose_image_for_workspace: {
        chose_the: 'Choose an {image} for your {el} workspace.',
        image: 'image'
      },
      this_image_is_visible_in: 'This image is visible in the most of the views, at the top left.',
      workspace_name: 'Workspace name',
      chose_name_for_workspace: {
        chose_the: 'Choose the {0} that will be displayed for this workspace.',
        name: 'name'
      },
      oirganization_name: 'Organization name',
      currency: 'Currency',
      set_up_curency_and_billable_projects: {
        set_up: 'Set up the the {currency_symbol} for reports and data exports in your {billable_projects}.',
        currency_symbol: 'currency symbol',
        billable_projects: 'billable projects'
      },
      show_working_time_dashboard: 'Show working time on dashboard',
      let_temmates_see_their_work: 'Let your teammates see their working time in their dashboard.',
      labour_cost: 'Labour cost',
      set_up_cost: {
        set_up_avarage_hourly_cost: "Set up the the average hourly cost of your members and see how much projects cost to your company.\n        {br}\n        You can also set this for individual members from your {team_members_view}.",
        team_members_view: 'Team members view'
      },
      register_time_for_user: 'Register time for other users',
      all_admins_on_this_workspace: {
        all_admins: 'All admins on this workspace will be able to {0} for other users.',
        can_create_entries: 'create time entries'
      },
      enabling_this_feature: {
        enabling_feature: 'Enabling this feature {0} in the register time entries dialog.',
        add_user_option: 'adds a user option'
      },
      note_timers_cant_be_started_by_users: 'Please note: timers cannot be started for other users.',
      // here
      working_hours: {
        title: 'Working hours',
        description: {
          set_default_working_days: 'Set availability and working days for users in your workspace.',
          set_individual_working_days: 'You can also set this for individual members from your {0}.',
          team_members_view: 'Team members view'
        }
      },
      storage_capacity: {
        title: 'Storage capacity',
        description: {
          workspace_max_attachments_size: 'Every account has a maximum space available of {0} (paid  license) to be used for the attachments.',
          size_per_user: '{size_in_mb}MB for every active user',
          workspace_max_attachments_size_example: 'For example, if you have 3 paid licenses, the available space is {totalSize}MB, {regardless} the user who\'s uploading files.',
          regardless: 'regardless'
        },
        space_used_out_of_max: '{spaceUsed} used out of {maxSize}'
      },
      export_workspace_data: 'Export workspace data',
      export_data_will_generate_csv: 'Exporting your data will generate a CSV file (that you can open with Excel) containing all your workspace\'s time entries.',
      this_will_be_sent_to_all_admins: 'This file will be sent to all the workspace admins e-mail addresses in a few minutes.',
      exporting: 'Exporting...',
      delete_workspace: 'Delete workspace',
      once_you_confirm_will_be_deleted: 'Once you confirm, your workspace {el} will be deleted.',
      evrything_will_be_deleted: 'All entries, timers, projects, clients, users and any other data of this workspace will be deleted.',
      this_is_not_possible_undo_action: 'Please note that it is NOT possible to undo this action.',
      export_data_before_workspace_deletion: 'Export data before workspace deletion (a link to the CSV file, valid for 48h, will be sent to all workspace owners)',
      type_delete: 'Type \'{action}\'',
      export_request_processed: 'Your data export request is being processed, you (and the other workspace admins) will receive a zip file in your inbox within a few minutes.',
      account_scheduled_for_deletion: 'Your account is scheduled for deletion.',
      error_on_deletion: 'Something went wrong.',
      authentication_methods: 'Authentication methods',
      configure_the_allowed_authentication: 'Configure the allowed authentication methods for the workspace.',
      require_password_or_google_microsoft: 'Require password or Google/Microsoft sign on',
      require_google_sigin: 'Require Google sign on for everyone',
      require_microsoft_sigin: 'Require Microsoft sign on for everyone',
      configure_sso: 'Configure SSO (SAML2.0)',
      require_authentication_saml: 'Require authentication through SAML2.0',
      saml_endpoint: 'SAML Endpoint URL (ACS)',
      timeneye_endpoint_expecting: 'Timeneye endpoint expecting authentication payload from a SAML Identify Provider.',
      issuer_id: 'Issuer ID',
      the_entity_id: 'The entity ID of the Identity provider.',
      login_url: 'Login URL (IDP)',
      the_url_used: 'The URL used for logging into the SAML Identity Provider.',
      x509_certificate: 'X.509 Certificate',
      the_signing_key: 'The signing key of the SAML Identity Provider.',
      allow_username_password_auth: 'Allow username/password login',
      turn_off_when_completed_testing_login: 'Turn this off when you have completed testing login via your Identity Provider.',
      download_sp_metadata: 'Download SP Metadata',
      allow_third_party_apps: 'Allow third-party apps',
      enable_disable_possibility_to_auth_third_party: 'Enable/disable the possibility to authorize third-party developers apps to your workspace users.',
      downloading_metadata: 'Downloading Metadata...',
      entries_lock: 'Entries lock',
      select_date_to_lock_all_entries: 'Select a date to lock all the time entries.',
      after_enabling_this: {
        after_enabling_all_entries: 'After enabling this setting, all time entries and pending/active timers {0} periodically according to the selected recurrence.',
        will_be_locked: 'will be automatically locked'
      },
      all_entry_will_still_be_visible: 'All locked entries will still be visible, but users will not be able to track or edit the time before the last locked date.',
      note_entry_lock_procesed_at_midnight: 'Please note: the entry lock will be processed at midnight of your timezone.',
      type_valid_day: 'Please type a valid day number',
      last_locked_date: 'Last locked date',
      expense_management: 'Expense management',
      monitor_expenses: {
        monitor_in_timeneye: 'Monitor {0} in Timeneye and allocate them to specific projects, users, and clients.',
        expeses: 'expenses'
      },
      from_to_title: 'Timeline view',
      from_to_description: 'Shows all the time entries with clearly marked times of the day (e.g. from 09:00-10:00) in the dashboard.',
      bill_clients: 'Bill clients accurately and calculate project profitability.',
      after_activating_a_new_section_will_appear: {
        after_activating: 'After activating this feature, a new section for {expenses} will appear in the Main menu, as well as an {expense_categories} section in your {workspace_settings}.',
        expenses: 'expenses',
        expense_categories: 'Expense categories',
        workspace_settings: 'Workspace settings'
      },
      project_management: 'Project management',
      manage_and_track_time_on_task: {
        manage_and_track_time: 'Manage and track time on your {0} directly in Timeneye.',
        tasks: 'tasks'
      },
      after_activating_this: {
        after_activating_a_new_tab_will_appear: 'After activating this feature, a new tab {0} will appear in the Project details, after you enable the tasks for that project from the Project edit page.',
        tasks: 'tasks'
      },
      custom_report_logo: 'Custom Report Logo',
      chose_custom_image: {
        chose_custom: 'Choose a custom {0} for your reports.',
        image: 'image'
      },
      this_image_will_be_shown: 'This image will be shown in the top right corner of your PDF reports.',
      remove_logo: 'Remove logo',
      select_image_from_device: 'Drop your image or click here to select from your device',
      logo_should_be: 'The logo aspect ratio should be 4:1 (e.g. 400px x 100px)',
      maximum_uploade_size: 'Maximum upload size 2M (jpg, jpeg, png, bmp)',
      drop_your_image_anywhere: 'Drop your image anywhere or click here to select from your device ',
      max_upload_size: 'Maximum upload size 2M (jpg, jpeg, png, bmp, svg, webp)',
      required_fields: 'Required fields',
      required_fields_description: 'Make sure to set certain fields as required for all users in your workspace. This prevents team members from forgetting important information and ensures consistency in all the time entries.',
      required_fields_entry_notes: 'Adding {notes} is required when creating a time entry',
      required_fields_notes: 'Notes',
      required_fields_expense_project: 'Selecting a {project} is required when creating an expense',
      required_fields_project: 'Project'
    }
  },
  layouts: {
    timesheet: 'Timesheet',
    trial_ended: 'TRIAL ENDED',
    trial_left: 'TRIAL {el} left | TRIAL {el} left',
    subscription_expired: 'SUBSCRIPTION EXPIRED',
    grace_period: 'GRACE PERIOD: {number} day left | GRACE PERIOD: {number} days left',
    plan_billing: 'Plan & billing',
    profile: 'Profile',
    product_updates: 'Product updates',
    developers_portal: 'Developers portal',
    logout_all_profiles: 'Logout all profiles',
    user_profile: 'User profile',
    collapse_menu: 'Collapse menu',
    expand_menu: 'Expand menu'
  },
  pages: {
    billing: {
      current_plan: 'Current plan:',
      trial_flag: 'Trial',
      plan_pricing_details: "${monthlyPrice}/user/month if paid monthly, or ${yearlyPrice}/user/month if paid yearly.",
      plan_expiration: 'Expiration:',
      trial_plan_expiration: 'Trial expiration:',
      microsoft_marketplace_description: 'Purchase your subscription on the Microsoft marketplace',
      stripe_description: 'Use your credit card details to proceed with the payment',
      plan_selection_action: 'Start your subscription',
      manage_microsoft_licenses_action: 'Manage your license on the Microsoft Marketplace.',
      licenses_number: 'Licenses number: {licensesNumber}',
      days_left: {
        you_have_x_days: 'You have {number_days} left on your {trial}',
        number_days: '{number} DAYS',
        free_trial: 'free trial.'
      },
      number_active_licenses: '{number} active licenses',
      upgrade_plan: 'Upgrade plan',
      manage_licenses: 'Manage licenses',
      manage_subscription: 'Manage subscription',
      next_renewal: 'Next renewal: {date}',
      renewal_information: 'RENEWAL INFORMATION',
      no_active_subscription: 'You do not have any active subscription. Your expiration currently is {date}.',
      current_payment_is: 'Your current {duration} payment is {price} USD, with a total of {limit_user} licenses.',
      monthly_duration: 'monthly',
      yearly_duration: 'yearly',
      billing_history: 'Billing history',
      see_full_plan: 'See full plan comparison',
      invoices: 'Invoices',
      billing_date: 'Billing date',
      please_suscribe: '{is_expired} Please start your subscription to continue using Timeneye',
      is_expired: 'Your Timeneye subscription has expired.',
      start_subscription: 'Start subscription',
      licenses_updated: 'The licenses number have been updated',
      need_payment_confirmation: 'You need to confirm the payment to proceed',
      confirm_payment: 'Confirm payment'
    },
    automation_settings: 'Automation Settings',
    you_cant_access_your_biling_status: 'You cannot access your billing information from Microsoft Teams.',
    click_here_to_change_settings: 'Click here to change your Billing settings on Timeneye.',
    developers_panel: 'Developers panel',
    create_and_manage_your_applications: 'Create and manage your applications to give your users access to the Timeneye APIs.',
    how_to_get_started: 'How to get started',
    applications: 'Applications',
    no_apps_created: 'No apps created',
    create_new_app: 'Create new app',
    delete_app: 'Delete app',
    delete_app_confirmation: 'Are you sure you want to delete the app {app_name}?',
    app_deleted: 'App deleted.',
    email_verification: 'Email verification',
    enter_code_you_recived: 'Enter the code you received by email to verify your email address.',
    verify_email: 'Verify email',
    verifying_email: 'Verifying email...',
    go_back_to_login: 'Go back to login form',
    invalid_recaptcha: 'Invalid recaptcha',
    the_code_not_valid: 'The code is not valid',
    error_message: {
      message: 'Sorry, nothing here...{0}',
      error: '(404)'
    },
    go_back: 'Go back',
    saml_sign_on: 'SAML single sign-on',
    use_email_that_matches_sso: 'Use the email that matches your SSO credentials .',
    forgot_your_password: 'Forgot your password?',
    sign_with_microsoft: 'Sign in with Microsoft',
    sign_with_google: 'Sign in with Google',
    sign_with_saml: 'Sign in with SAML SSO',
    other_ways_to_sign_in: 'Other ways to sign in',
    dont_have_workspace: 'Don\'t have a workspace?',
    error_during_authentication: 'A problem occurred during authentication',
    fail_log_in: 'Failed to log in. Email and/or password may be missing.',
    confirm_password: 'Confirm your password',
    your_password_has_been_chenged: 'Your password has been changed. {br}You may now login with your new credentials.',
    enter_your_email_for_reset: 'Enter your e-mail address and we\'ll send you instructions on how to reset your password.',
    type_your_email: 'Type your email address',
    send_reset_instructions: 'Send me reset instructions',
    sending_reset_instructions: 'Sending reset instructions...',
    you_should_recive_an_email: 'You should receive an email with the reset link in a few seconds.',
    if_dont_recive_it: 'If you don\'t get an email from us within a few minutes please be sure to check your spam filter.',
    trusted_by: 'Trusted by 800+ companies in 50 countries',
    sign_up_for_free: 'Sign up for free',
    join_timeneye_for_free: 'Join Timeneye for free.',
    no_credit_card_needed: 'No credit card needed.',
    by_signing_up_i_agree: {
      by_signing: 'By signing up, I agree to ours {privacy_policy} and {terms_of_service}',
      privacy_policy: 'Privacy policy',
      terms_of_service: 'Terms of Service'
    },
    continue_sign_up: 'Continue Sign Up here',
    open_with_teams: 'Open in Microsoft Teams',
    sign_up_with_microsoft: 'Sign up with Microsoft',
    sign_up_with_email: 'Sign up with your email',
    min_length_name: 'Your full name must be at least 3 characters',
    email_required: 'The email is required',
    work_email: 'Work e-mail',
    or_sign_up_with: 'Or Sign up with',
    aleardy_have_an_account_sign_in: {
      aleardy_have_an_account: 'Already have an account?{0}',
      sig_in: 'Sign In'
    },
    track_your_projects_in_timeneye: 'Track your projects in Timeneye and boost your productivity',
    manage_projects: 'Manage Projects:',
    track_time_on_project: 'track time of your project life cycle, keep an eye on budgets and stay connected with your team.',
    report_analyze: 'Report & Analyze:',
    create_visual_report: 'create a visual report to analyze productivity and make better estimates for the future.',
    accurate_billing: 'Accurate billing:',
    deliver_billable_minute: 'deliver on time and capture every billable minute worked across your entire team.',
    subscription_expired: 'Subscription expired',
    your_timeneye_subscription_expired: 'Your Timeneye subscription has expired.',
    contact_your_workspace: {
      workspace_owners: 'workspace owners',
      contact_your_workspace_owner_expired: 'Please contact your {workspace_owners} to renew you subscription {br} and continue using Timeneye.',
      contact_your_workspace_owner_trial_ended: 'Please contact your {workspace_owners} to upgrade to a paid plan {br} and continue using Timeneye.',
      contact_your_workspace_owner_unauthorized: 'Please contact your {workspace_owners} to continue using Timeneye.'
    },
    trial_ended: 'Trial ended',
    your_timeneye_trial_expired: 'Your Timeneye trial has ended.',
    unauthorized: 'Unauthorized',
    your_timeneye_user_has_been_disabled: 'Your Timeneye user has been disabled by an admin.',
    go_to_login_page: 'Go to login page',
    new_password: 'New password',
    or: 'Or',
    // between 2 buttons
    authenticating: 'Authenticating {integrationName}...'
  },
  mixins: {
    your_calendar_has_been_updated: 'Your calendar has been updated',
    failed_to_link_integration: 'Failed to link integration.',
    failed_to_get_integration: 'Failed to get integration.',
    error_during_authentication: 'A problem occurred during authentication',
    billable_time: 'Billable time',
    not_billable_time: 'Not billable time',
    billed_money: 'Billed money',
    billable_money: 'Billable money',
    total_money: 'Total money',
    total_cost: 'Total cost',
    billed_cost: 'Billed cost',
    unbilled_cost: 'Unbilled cost',
    total_profit: 'Total profit',
    total_unbilled: 'Total unbilled',
    billed_profit: 'Billed profit',
    unbilled_profit: 'Unbilled profit',
    favorite: 'Favorite',
    column_disable_if: 'This column is disabled if multiple projects are selected or if the project has no budget.',
    invitation_status: 'Invitation Status',
    labor_cost: 'Labor cost',
    locked_status: 'Locked status',
    locked: 'Locked',
    billing_status: 'Billing Status',
    total_expenses: 'Total expenses',
    unit_price: 'Unit Price',
    task_list: 'Task List',
    source: 'Source',
    progress: 'Progress',
    todo: 'Todo',
    billed_fixed_fee: 'Billed fixed fee',
    unbilled_fixed_fee: 'Unbilled fixed fee',
    billed_money_info: 'Billed money = billed labor + billed expenses + billed fixed fee',
    total_cost_info: 'Total costs = labor costs + total expenses',
    billed_labor: 'Billed labor',
    unbilled_labor: 'Unbilled labor'
  },
  notificationPanel: {
    general: 'General',
    announcements: 'Announcements'
  },
  app: {
    session_expired: 'Your session has expired. Please log in again to continue.',
    go_to_project: 'Go to project',
    go_to_integration: 'Go to integration',
    sidebar: {
      show: 'Show sidebar',
      collapse: 'Collapse sidebar',
      unpin: 'Unpin',
      pin: 'Pin',
      register_time: 'Register time',
      dashboard: 'Dashboard',
      dashboard_short: 'Dashboard',
      expenses: 'Expenses',
      entries_log: 'Entries log',
      entries_log_short: 'Entries log',
      team: 'Team',
      projects: 'Projects',
      clients: 'Clients',
      reports: 'Reports',
      tasks: 'Tasks',
      timesheet: 'Timesheet',
      approvals: 'Approvals',
      integrations: 'Integrations',
      data_management: 'Data management',
      data_management_short: 'Data',
      tags: 'Tags',
      phase_categories: 'Phase categories',
      expense_categories: 'Expense categories',
      import_data: 'Import data',
      settings: 'Settings',
      subscription: 'Subscription',
      notifications: 'Notifications',
      support: 'Support',
      help_center: 'Help center',
      tutorial_videos: 'Tutorial videos',
      product_updates: 'Product updates',
      feature_request: 'Request a feature',
      developers_portal: 'Developers portal',
      contact_support: 'Contact support',
      subscription_expired: 'SUBSCRIPTION EXPIRED',
      x_day_left: '{number} day left | {number} days left',
      personal_settings: 'Personal settings',
      switch_account: 'Switch account',
      switch_bach_to_old_version: 'Switch back to the old version',
      new_version_avaiable: 'New version available!',
      click_here_to_update: 'Click here to update',
      logout: 'Logout | Logout all profiles'
    }
  },
  boot: {
    can_only_see_track_edit: 'Can only see, track and edit their own timers and entries',
    can_see_track_edit: 'Can see, track and edit timers and entries of anyone in the team',
    it_is_admin: 'It\'s an admin but can manage billing details and delete the workspace'
  }
};